(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('react-event-listener'), require('react-dom')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react', 'react-event-listener', 'react-dom'], factory) :
  (factory((global.uiuiui = {}),global.React,global.EventListener,global.ReactDOM));
}(this, (function (exports,React,EventListener,ReactDOM) { 'use strict';

  React = React && React.hasOwnProperty('default') ? React['default'] : React;
  EventListener = EventListener && EventListener.hasOwnProperty('default') ? EventListener['default'] : EventListener;
  ReactDOM = ReactDOM && ReactDOM.hasOwnProperty('default') ? ReactDOM['default'] : ReactDOM;

  var noop = function noop() {};
  var identity = function identity(val) {
    return val;
  };
  var returnTrue = function returnTrue(val) {
    return true;
  };

  var classCallCheck = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  var createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var defineProperty = function (obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  };

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var inherits = function (subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  };

  var possibleConstructorReturn = function (self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  };

  /*
  	Component: Position
  	------------------------------------------

  	This low-level component will relay the user coordinates
  	on the `onChange` callback, as long as it is enabled
  	through the `interacting` boolean property.

  	It will also relay the end of the interaction 
  	on the `onEnd` callback.

  */

  var Position = function (_React$PureComponent) {
  	inherits(Position, _React$PureComponent);

  	function Position(props) {
  		classCallCheck(this, Position);

  		var _this = possibleConstructorReturn(this, (Position.__proto__ || Object.getPrototypeOf(Position)).call(this, props));

  		_this.onChange = _this.onChange.bind(_this);
  		_this.onEnd = _this.onEnd.bind(_this);
  		return _this;
  	}

  	createClass(Position, [{
  		key: 'onChange',
  		value: function onChange(e) {
  			this.props.onChange({
  				x: e.clientX,
  				y: e.clientY,
  				event: e
  			}, this.props.property);
  			e.preventDefault();
  		}
  	}, {
  		key: 'onEnd',
  		value: function onEnd(e) {
  			this.props.onEnd({
  				x: e.clientX,
  				y: e.clientY,
  				event: e
  			}, this.props.property);
  		}
  	}, {
  		key: 'render',
  		value: function render() {
  			return React.createElement(EventListener, {
  				target: 'document',
  				onMouseMove: this.onChange,
  				onMouseUp: this.onEnd
  			});
  		}
  	}]);
  	return Position;
  }(React.PureComponent);

  Position.defaultProps = {
  	onChange: noop,
  	onEnd: noop,
  	property: undefined,
  	interacting: false
  };

  function ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
  }

  function bisector(compare) {
    if (compare.length === 1) compare = ascendingComparator(compare);
    return {
      left: function(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) < 0) lo = mid + 1;
          else hi = mid;
        }
        return lo;
      },
      right: function(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) > 0) hi = mid;
          else lo = mid + 1;
        }
        return lo;
      }
    };
  }

  function ascendingComparator(f) {
    return function(d, x) {
      return ascending(f(d), x);
    };
  }

  var ascendingBisect = bisector(ascending);
  var bisectRight = ascendingBisect.right;

  var e10 = Math.sqrt(50),
      e5 = Math.sqrt(10),
      e2 = Math.sqrt(2);

  function ticks(start, stop, count) {
    var reverse,
        i = -1,
        n,
        ticks,
        step;

    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [start];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

    if (step > 0) {
      start = Math.ceil(start / step);
      stop = Math.floor(stop / step);
      ticks = new Array(n = Math.ceil(stop - start + 1));
      while (++i < n) ticks[i] = (start + i) * step;
    } else {
      start = Math.floor(start * step);
      stop = Math.ceil(stop * step);
      ticks = new Array(n = Math.ceil(start - stop + 1));
      while (++i < n) ticks[i] = (start - i) / step;
    }

    if (reverse) ticks.reverse();

    return ticks;
  }

  function tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count),
        power = Math.floor(Math.log(step) / Math.LN10),
        error = step / Math.pow(10, power);
    return power >= 0
        ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
        : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
  }

  function tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count),
        step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
        error = step0 / step1;
    if (error >= e10) step1 *= 10;
    else if (error >= e5) step1 *= 5;
    else if (error >= e2) step1 *= 2;
    return stop < start ? -step1 : step1;
  }

  var prefix = "$";

  function Map() {}

  Map.prototype = map$1.prototype = {
    constructor: Map,
    has: function(key) {
      return (prefix + key) in this;
    },
    get: function(key) {
      return this[prefix + key];
    },
    set: function(key, value) {
      this[prefix + key] = value;
      return this;
    },
    remove: function(key) {
      var property = prefix + key;
      return property in this && delete this[property];
    },
    clear: function() {
      for (var property in this) if (property[0] === prefix) delete this[property];
    },
    keys: function() {
      var keys = [];
      for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
      return keys;
    },
    values: function() {
      var values = [];
      for (var property in this) if (property[0] === prefix) values.push(this[property]);
      return values;
    },
    entries: function() {
      var entries = [];
      for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
      return entries;
    },
    size: function() {
      var size = 0;
      for (var property in this) if (property[0] === prefix) ++size;
      return size;
    },
    empty: function() {
      for (var property in this) if (property[0] === prefix) return false;
      return true;
    },
    each: function(f) {
      for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
    }
  };

  function map$1(object, f) {
    var map = new Map;

    // Copy constructor.
    if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

    // Index array by numeric index or specified key function.
    else if (Array.isArray(object)) {
      var i = -1,
          n = object.length,
          o;

      if (f == null) while (++i < n) map.set(i, object[i]);
      else while (++i < n) map.set(f(o = object[i], i, object), o);
    }

    // Convert object to map.
    else if (object) for (var key in object) map.set(key, object[key]);

    return map;
  }

  function Set() {}

  var proto = map$1.prototype;

  Set.prototype = set$1.prototype = {
    constructor: Set,
    has: proto.has,
    add: function(value) {
      value += "";
      this[prefix + value] = value;
      return this;
    },
    remove: proto.remove,
    clear: proto.clear,
    values: proto.keys,
    size: proto.size,
    empty: proto.empty,
    each: proto.each
  };

  function set$1(object, f) {
    var set = new Set;

    // Copy constructor.
    if (object instanceof Set) object.each(function(value) { set.add(value); });

    // Otherwise, assume it’s an array.
    else if (object) {
      var i = -1, n = object.length;
      if (f == null) while (++i < n) set.add(object[i]);
      else while (++i < n) set.add(f(object[i], i, object));
    }

    return set;
  }

  var array$1 = Array.prototype;

  var map$2 = array$1.map;
  var slice$1 = array$1.slice;

  function define(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
  }

  function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for (var key in definition) prototype[key] = definition[key];
    return prototype;
  }

  function Color() {}

  var darker = 0.7;
  var brighter = 1 / darker;

  var reI = "\\s*([+-]?\\d+)\\s*",
      reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
      reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
      reHex3 = /^#([0-9a-f]{3})$/,
      reHex6 = /^#([0-9a-f]{6})$/,
      reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
      reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
      reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
      reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
      reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
      reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

  var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
  };

  define(Color, color, {
    displayable: function() {
      return this.rgb().displayable();
    },
    toString: function() {
      return this.rgb() + "";
    }
  });

  function color(format) {
    var m;
    format = (format + "").trim().toLowerCase();
    return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
        : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
        : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
        : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
        : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
        : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
        : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
        : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
        : named.hasOwnProperty(format) ? rgbn(named[format])
        : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
        : null;
  }

  function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
  }

  function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
  }

  function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
  }

  function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
  }

  function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
  }

  define(Rgb, rgb, extend(Color, {
    brighter: function(k) {
      k = k == null ? brighter : Math.pow(brighter, k);
      return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
      k = k == null ? darker : Math.pow(darker, k);
      return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
      return this;
    },
    displayable: function() {
      return (0 <= this.r && this.r <= 255)
          && (0 <= this.g && this.g <= 255)
          && (0 <= this.b && this.b <= 255)
          && (0 <= this.opacity && this.opacity <= 1);
    },
    toString: function() {
      var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
      return (a === 1 ? "rgb(" : "rgba(")
          + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
          + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
          + Math.max(0, Math.min(255, Math.round(this.b) || 0))
          + (a === 1 ? ")" : ", " + a + ")");
    }
  }));

  function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
  }

  function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255,
        g = o.g / 255,
        b = o.b / 255,
        min = Math.min(r, g, b),
        max = Math.max(r, g, b),
        h = NaN,
        s = max - min,
        l = (max + min) / 2;
    if (s) {
      if (r === max) h = (g - b) / s + (g < b) * 6;
      else if (g === max) h = (b - r) / s + 2;
      else h = (r - g) / s + 4;
      s /= l < 0.5 ? max + min : 2 - max - min;
      h *= 60;
    } else {
      s = l > 0 && l < 1 ? 0 : h;
    }
    return new Hsl(h, s, l, o.opacity);
  }

  function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
  }

  function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
  }

  define(Hsl, hsl, extend(Color, {
    brighter: function(k) {
      k = k == null ? brighter : Math.pow(brighter, k);
      return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
      k = k == null ? darker : Math.pow(darker, k);
      return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
      var h = this.h % 360 + (this.h < 0) * 360,
          s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
          l = this.l,
          m2 = l + (l < 0.5 ? l : 1 - l) * s,
          m1 = 2 * l - m2;
      return new Rgb(
        hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
        hsl2rgb(h, m1, m2),
        hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
        this.opacity
      );
    },
    displayable: function() {
      return (0 <= this.s && this.s <= 1 || isNaN(this.s))
          && (0 <= this.l && this.l <= 1)
          && (0 <= this.opacity && this.opacity <= 1);
    }
  }));

  /* From FvD 13.37, CSS Color Module Level 3 */
  function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60
        : h < 180 ? m2
        : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
        : m1) * 255;
  }

  var deg2rad = Math.PI / 180;
  var rad2deg = 180 / Math.PI;

  var Kn = 18,
      Xn = 0.950470, // D65 standard referent
      Yn = 1,
      Zn = 1.088830,
      t0 = 4 / 29,
      t1 = 6 / 29,
      t2 = 3 * t1 * t1,
      t3 = t1 * t1 * t1;

  function labConvert(o) {
    if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof Hcl) {
      var h = o.h * deg2rad;
      return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
    }
    if (!(o instanceof Rgb)) o = rgbConvert(o);
    var b = rgb2xyz(o.r),
        a = rgb2xyz(o.g),
        l = rgb2xyz(o.b),
        x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
        y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
        z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
    return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
  }

  function lab(l, a, b, opacity) {
    return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
  }

  function Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
  }

  define(Lab, lab, extend(Color, {
    brighter: function(k) {
      return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker: function(k) {
      return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb: function() {
      var y = (this.l + 16) / 116,
          x = isNaN(this.a) ? y : y + this.a / 500,
          z = isNaN(this.b) ? y : y - this.b / 200;
      y = Yn * lab2xyz(y);
      x = Xn * lab2xyz(x);
      z = Zn * lab2xyz(z);
      return new Rgb(
        xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
        xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
        xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
        this.opacity
      );
    }
  }));

  function xyz2lab(t) {
    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
  }

  function lab2xyz(t) {
    return t > t1 ? t * t * t : t2 * (t - t0);
  }

  function xyz2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
  }

  function rgb2xyz(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
  }

  function hclConvert(o) {
    if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof Lab)) o = labConvert(o);
    var h = Math.atan2(o.b, o.a) * rad2deg;
    return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
  }

  function hcl(h, c, l, opacity) {
    return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
  }

  function Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
  }

  define(Hcl, hcl, extend(Color, {
    brighter: function(k) {
      return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
    },
    darker: function(k) {
      return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
    },
    rgb: function() {
      return labConvert(this).rgb();
    }
  }));

  var A = -0.14861,
      B = +1.78277,
      C = -0.29227,
      D = -0.90649,
      E = +1.97294,
      ED = E * D,
      EB = E * B,
      BC_DA = B * C - D * A;

  function cubehelixConvert(o) {
    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Rgb)) o = rgbConvert(o);
    var r = o.r / 255,
        g = o.g / 255,
        b = o.b / 255,
        l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
        bl = b - l,
        k = (E * (g - l) - C * bl) / D,
        s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
        h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
  }

  function cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
  }

  function Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
  }

  define(Cubehelix, cubehelix, extend(Color, {
    brighter: function(k) {
      k = k == null ? brighter : Math.pow(brighter, k);
      return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
      k = k == null ? darker : Math.pow(darker, k);
      return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
      var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
          l = +this.l,
          a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
          cosh = Math.cos(h),
          sinh = Math.sin(h);
      return new Rgb(
        255 * (l + a * (A * cosh + B * sinh)),
        255 * (l + a * (C * cosh + D * sinh)),
        255 * (l + a * (E * cosh)),
        this.opacity
      );
    }
  }));

  function constant$1(x) {
    return function() {
      return x;
    };
  }

  function linear(a, d) {
    return function(t) {
      return a + t * d;
    };
  }

  function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
      return Math.pow(a + t * b, y);
    };
  }

  function gamma(y) {
    return (y = +y) === 1 ? nogamma : function(a, b) {
      return b - a ? exponential(a, b, y) : constant$1(isNaN(a) ? b : a);
    };
  }

  function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : constant$1(isNaN(a) ? b : a);
  }

  var rgb$1 = (function rgbGamma(y) {
    var color$$1 = gamma(y);

    function rgb$$1(start, end) {
      var r = color$$1((start = rgb(start)).r, (end = rgb(end)).r),
          g = color$$1(start.g, end.g),
          b = color$$1(start.b, end.b),
          opacity = nogamma(start.opacity, end.opacity);
      return function(t) {
        start.r = r(t);
        start.g = g(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
      };
    }

    rgb$$1.gamma = rgbGamma;

    return rgb$$1;
  })(1);

  function array$2(a, b) {
    var nb = b ? b.length : 0,
        na = a ? Math.min(nb, a.length) : 0,
        x = new Array(na),
        c = new Array(nb),
        i;

    for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
    for (; i < nb; ++i) c[i] = b[i];

    return function(t) {
      for (i = 0; i < na; ++i) c[i] = x[i](t);
      return c;
    };
  }

  function date(a, b) {
    var d = new Date;
    return a = +a, b -= a, function(t) {
      return d.setTime(a + b * t), d;
    };
  }

  function number$1(a, b) {
    return a = +a, b -= a, function(t) {
      return a + b * t;
    };
  }

  function object(a, b) {
    var i = {},
        c = {},
        k;

    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};

    for (k in b) {
      if (k in a) {
        i[k] = value(a[k], b[k]);
      } else {
        c[k] = b[k];
      }
    }

    return function(t) {
      for (k in i) c[k] = i[k](t);
      return c;
    };
  }

  var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
      reB = new RegExp(reA.source, "g");

  function zero(b) {
    return function() {
      return b;
    };
  }

  function one(b) {
    return function(t) {
      return b(t) + "";
    };
  }

  function string(a, b) {
    var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
        am, // current match in a
        bm, // current match in b
        bs, // string preceding current number in b, if any
        i = -1, // index in s
        s = [], // string constants and placeholders
        q = []; // number interpolators

    // Coerce inputs to strings.
    a = a + "", b = b + "";

    // Interpolate pairs of numbers in a & b.
    while ((am = reA.exec(a))
        && (bm = reB.exec(b))) {
      if ((bs = bm.index) > bi) { // a string precedes the next number in b
        bs = b.slice(bi, bs);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
      }
      if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
        if (s[i]) s[i] += bm; // coalesce with previous string
        else s[++i] = bm;
      } else { // interpolate non-matching numbers
        s[++i] = null;
        q.push({i: i, x: number$1(am, bm)});
      }
      bi = reB.lastIndex;
    }

    // Add remains of b.
    if (bi < b.length) {
      bs = b.slice(bi);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }

    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? (q[0]
        ? one(q[0].x)
        : zero(b))
        : (b = q.length, function(t) {
            for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
            return s.join("");
          });
  }

  function value(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? constant$1(b)
        : (t === "number" ? number$1
        : t === "string" ? ((c = color(b)) ? (b = c, rgb$1) : string)
        : b instanceof color ? rgb$1
        : b instanceof Date ? date
        : Array.isArray(b) ? array$2
        : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
        : number$1)(a, b);
  }

  function interpolateRound(a, b) {
    return a = +a, b -= a, function(t) {
      return Math.round(a + b * t);
    };
  }

  var degrees = 180 / Math.PI;

  var rho = Math.SQRT2;

  function constant$2(x) {
    return function() {
      return x;
    };
  }

  function number$2(x) {
    return +x;
  }

  var unit = [0, 1];

  function deinterpolateLinear(a, b) {
    return (b -= (a = +a))
        ? function(x) { return (x - a) / b; }
        : constant$2(b);
  }

  function deinterpolateClamp(deinterpolate) {
    return function(a, b) {
      var d = deinterpolate(a = +a, b = +b);
      return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
    };
  }

  function reinterpolateClamp(reinterpolate) {
    return function(a, b) {
      var r = reinterpolate(a = +a, b = +b);
      return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
    };
  }

  function bimap(domain, range$$1, deinterpolate, reinterpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
    if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
    else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
    return function(x) { return r0(d0(x)); };
  }

  function polymap(domain, range$$1, deinterpolate, reinterpolate) {
    var j = Math.min(domain.length, range$$1.length) - 1,
        d = new Array(j),
        r = new Array(j),
        i = -1;

    // Reverse descending domains.
    if (domain[j] < domain[0]) {
      domain = domain.slice().reverse();
      range$$1 = range$$1.slice().reverse();
    }

    while (++i < j) {
      d[i] = deinterpolate(domain[i], domain[i + 1]);
      r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
    }

    return function(x) {
      var i = bisectRight(domain, x, 1, j) - 1;
      return r[i](d[i](x));
    };
  }

  function copy(source, target) {
    return target
        .domain(source.domain())
        .range(source.range())
        .interpolate(source.interpolate())
        .clamp(source.clamp());
  }

  // deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
  // reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
  function continuous(deinterpolate, reinterpolate) {
    var domain = unit,
        range$$1 = unit,
        interpolate$$1 = value,
        clamp = false,
        piecewise,
        output,
        input;

    function rescale() {
      piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
      output = input = null;
      return scale;
    }

    function scale(x) {
      return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
    }

    scale.invert = function(y) {
      return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
    };

    scale.domain = function(_) {
      return arguments.length ? (domain = map$2.call(_, number$2), rescale()) : domain.slice();
    };

    scale.range = function(_) {
      return arguments.length ? (range$$1 = slice$1.call(_), rescale()) : range$$1.slice();
    };

    scale.rangeRound = function(_) {
      return range$$1 = slice$1.call(_), interpolate$$1 = interpolateRound, rescale();
    };

    scale.clamp = function(_) {
      return arguments.length ? (clamp = !!_, rescale()) : clamp;
    };

    scale.interpolate = function(_) {
      return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
    };

    return rescale();
  }

  // Computes the decimal coefficient and exponent of the specified number x with
  // significant digits p, where x is positive and p is in [1, 21] or undefined.
  // For example, formatDecimal(1.23) returns ["123", 0].
  function formatDecimal(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);

    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
      coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
      +x.slice(i + 1)
    ];
  }

  function exponent(x) {
    return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
  }

  function formatGroup(grouping, thousands) {
    return function(value, width) {
      var i = value.length,
          t = [],
          j = 0,
          g = grouping[0],
          length = 0;

      while (i > 0 && g > 0) {
        if (length + g + 1 > width) g = Math.max(1, width - length);
        t.push(value.substring(i -= g, i + g));
        if ((length += g + 1) > width) break;
        g = grouping[j = (j + 1) % grouping.length];
      }

      return t.reverse().join(thousands);
    };
  }

  function formatNumerals(numerals) {
    return function(value) {
      return value.replace(/[0-9]/g, function(i) {
        return numerals[+i];
      });
    };
  }

  function formatDefault(x, p) {
    x = x.toPrecision(p);

    out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
      switch (x[i]) {
        case ".": i0 = i1 = i; break;
        case "0": if (i0 === 0) i0 = i; i1 = i; break;
        case "e": break out;
        default: if (i0 > 0) i0 = 0; break;
      }
    }

    return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
  }

  var prefixExponent;

  function formatPrefixAuto(x, p) {
    var d = formatDecimal(x, p);
    if (!d) return x + "";
    var coefficient = d[0],
        exponent = d[1],
        i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
        n = coefficient.length;
    return i === n ? coefficient
        : i > n ? coefficient + new Array(i - n + 1).join("0")
        : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
        : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
  }

  function formatRounded(x, p) {
    var d = formatDecimal(x, p);
    if (!d) return x + "";
    var coefficient = d[0],
        exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
        : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
        : coefficient + new Array(exponent - coefficient.length + 2).join("0");
  }

  var formatTypes = {
    "": formatDefault,
    "%": function(x, p) { return (x * 100).toFixed(p); },
    "b": function(x) { return Math.round(x).toString(2); },
    "c": function(x) { return x + ""; },
    "d": function(x) { return Math.round(x).toString(10); },
    "e": function(x, p) { return x.toExponential(p); },
    "f": function(x, p) { return x.toFixed(p); },
    "g": function(x, p) { return x.toPrecision(p); },
    "o": function(x) { return Math.round(x).toString(8); },
    "p": function(x, p) { return formatRounded(x * 100, p); },
    "r": formatRounded,
    "s": formatPrefixAuto,
    "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
    "x": function(x) { return Math.round(x).toString(16); }
  };

  // [[fill]align][sign][symbol][0][width][,][.precision][type]
  var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;

  function formatSpecifier(specifier) {
    return new FormatSpecifier(specifier);
  }

  formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

  function FormatSpecifier(specifier) {
    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);

    var match,
        fill = match[1] || " ",
        align = match[2] || ">",
        sign = match[3] || "-",
        symbol = match[4] || "",
        zero = !!match[5],
        width = match[6] && +match[6],
        comma = !!match[7],
        precision = match[8] && +match[8].slice(1),
        type = match[9] || "";

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // Map invalid types to the default format.
    else if (!formatTypes[type]) type = "";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

    this.fill = fill;
    this.align = align;
    this.sign = sign;
    this.symbol = symbol;
    this.zero = zero;
    this.width = width;
    this.comma = comma;
    this.precision = precision;
    this.type = type;
  }

  FormatSpecifier.prototype.toString = function() {
    return this.fill
        + this.align
        + this.sign
        + this.symbol
        + (this.zero ? "0" : "")
        + (this.width == null ? "" : Math.max(1, this.width | 0))
        + (this.comma ? "," : "")
        + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
        + this.type;
  };

  function identity$3(x) {
    return x;
  }

  var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

  function formatLocale(locale) {
    var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity$3,
        currency = locale.currency,
        decimal = locale.decimal,
        numerals = locale.numerals ? formatNumerals(locale.numerals) : identity$3,
        percent = locale.percent || "%";

    function newFormat(specifier) {
      specifier = formatSpecifier(specifier);

      var fill = specifier.fill,
          align = specifier.align,
          sign = specifier.sign,
          symbol = specifier.symbol,
          zero = specifier.zero,
          width = specifier.width,
          comma = specifier.comma,
          precision = specifier.precision,
          type = specifier.type;

      // Compute the prefix and suffix.
      // For SI-prefix, the suffix is lazily computed.
      var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
          suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

      // What format function should we use?
      // Is this an integer type?
      // Can this type generate exponential notation?
      var formatType = formatTypes[type],
          maybeSuffix = !type || /[defgprs%]/.test(type);

      // Set the default precision if not specified,
      // or clamp the specified precision to the supported range.
      // For significant precision, it must be in [1, 21].
      // For fixed precision, it must be in [0, 20].
      precision = precision == null ? (type ? 6 : 12)
          : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
          : Math.max(0, Math.min(20, precision));

      function format(value) {
        var valuePrefix = prefix,
            valueSuffix = suffix,
            i, n, c;

        if (type === "c") {
          valueSuffix = formatType(value) + valueSuffix;
          value = "";
        } else {
          value = +value;

          // Perform the initial formatting.
          var valueNegative = value < 0;
          value = formatType(Math.abs(value), precision);

          // If a negative value rounds to zero during formatting, treat as positive.
          if (valueNegative && +value === 0) valueNegative = false;

          // Compute the prefix and suffix.
          valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
          valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

          // Break the formatted value into the integer “value” part that can be
          // grouped, and fractional or exponential “suffix” part that is not.
          if (maybeSuffix) {
            i = -1, n = value.length;
            while (++i < n) {
              if (c = value.charCodeAt(i), 48 > c || c > 57) {
                valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                value = value.slice(0, i);
                break;
              }
            }
          }
        }

        // If the fill character is not "0", grouping is applied before padding.
        if (comma && !zero) value = group(value, Infinity);

        // Compute the padding.
        var length = valuePrefix.length + value.length + valueSuffix.length,
            padding = length < width ? new Array(width - length + 1).join(fill) : "";

        // If the fill character is "0", grouping is applied after padding.
        if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

        // Reconstruct the final output based on the desired alignment.
        switch (align) {
          case "<": value = valuePrefix + value + valueSuffix + padding; break;
          case "=": value = valuePrefix + padding + value + valueSuffix; break;
          case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
          default: value = padding + valuePrefix + value + valueSuffix; break;
        }

        return numerals(value);
      }

      format.toString = function() {
        return specifier + "";
      };

      return format;
    }

    function formatPrefix(specifier, value) {
      var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
          e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
          k = Math.pow(10, -e),
          prefix = prefixes[8 + e / 3];
      return function(value) {
        return f(k * value) + prefix;
      };
    }

    return {
      format: newFormat,
      formatPrefix: formatPrefix
    };
  }

  var locale;
  var format;
  var formatPrefix;

  defaultLocale({
    decimal: ".",
    thousands: ",",
    grouping: [3],
    currency: ["$", ""]
  });

  function defaultLocale(definition) {
    locale = formatLocale(definition);
    format = locale.format;
    formatPrefix = locale.formatPrefix;
    return locale;
  }

  function precisionFixed(step) {
    return Math.max(0, -exponent(Math.abs(step)));
  }

  function precisionPrefix(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
  }

  function precisionRound(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, exponent(max) - exponent(step)) + 1;
  }

  function tickFormat(domain, count, specifier) {
    var start = domain[0],
        stop = domain[domain.length - 1],
        step = tickStep(start, stop, count == null ? 10 : count),
        precision;
    specifier = formatSpecifier(specifier == null ? ",f" : specifier);
    switch (specifier.type) {
      case "s": {
        var value = Math.max(Math.abs(start), Math.abs(stop));
        if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
        return formatPrefix(specifier, value);
      }
      case "":
      case "e":
      case "g":
      case "p":
      case "r": {
        if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
        break;
      }
      case "f":
      case "%": {
        if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
        break;
      }
    }
    return format(specifier);
  }

  function linearish(scale) {
    var domain = scale.domain;

    scale.ticks = function(count) {
      var d = domain();
      return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
    };

    scale.tickFormat = function(count, specifier) {
      return tickFormat(domain(), count, specifier);
    };

    scale.nice = function(count) {
      if (count == null) count = 10;

      var d = domain(),
          i0 = 0,
          i1 = d.length - 1,
          start = d[i0],
          stop = d[i1],
          step;

      if (stop < start) {
        step = start, start = stop, stop = step;
        step = i0, i0 = i1, i1 = step;
      }

      step = tickIncrement(start, stop, count);

      if (step > 0) {
        start = Math.floor(start / step) * step;
        stop = Math.ceil(stop / step) * step;
        step = tickIncrement(start, stop, count);
      } else if (step < 0) {
        start = Math.ceil(start * step) / step;
        stop = Math.floor(stop * step) / step;
        step = tickIncrement(start, stop, count);
      }

      if (step > 0) {
        d[i0] = Math.floor(start / step) * step;
        d[i1] = Math.ceil(stop / step) * step;
        domain(d);
      } else if (step < 0) {
        d[i0] = Math.ceil(start * step) / step;
        d[i1] = Math.floor(stop * step) / step;
        domain(d);
      }

      return scale;
    };

    return scale;
  }

  function linear$1() {
    var scale = continuous(deinterpolateLinear, number$1);

    scale.copy = function() {
      return copy(scale, linear$1());
    };

    return linearish(scale);
  }

  function identity$4() {
    var domain = [0, 1];

    function scale(x) {
      return +x;
    }

    scale.invert = scale;

    scale.domain = scale.range = function(_) {
      return arguments.length ? (domain = map$2.call(_, number$2), scale) : domain.slice();
    };

    scale.copy = function() {
      return identity$4().domain(domain);
    };

    return linearish(scale);
  }

  var t0$1 = new Date,
      t1$1 = new Date;

  function newInterval(floori, offseti, count, field) {

    function interval(date) {
      return floori(date = new Date(+date)), date;
    }

    interval.floor = interval;

    interval.ceil = function(date) {
      return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };

    interval.round = function(date) {
      var d0 = interval(date),
          d1 = interval.ceil(date);
      return date - d0 < d1 - date ? d0 : d1;
    };

    interval.offset = function(date, step) {
      return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };

    interval.range = function(start, stop, step) {
      var range = [], previous;
      start = interval.ceil(start);
      step = step == null ? 1 : Math.floor(step);
      if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
      do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
      while (previous < start && start < stop);
      return range;
    };

    interval.filter = function(test) {
      return newInterval(function(date) {
        if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
      }, function(date, step) {
        if (date >= date) {
          if (step < 0) while (++step <= 0) {
            while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
          } else while (--step >= 0) {
            while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
          }
        }
      });
    };

    if (count) {
      interval.count = function(start, end) {
        t0$1.setTime(+start), t1$1.setTime(+end);
        floori(t0$1), floori(t1$1);
        return Math.floor(count(t0$1, t1$1));
      };

      interval.every = function(step) {
        step = Math.floor(step);
        return !isFinite(step) || !(step > 0) ? null
            : !(step > 1) ? interval
            : interval.filter(field
                ? function(d) { return field(d) % step === 0; }
                : function(d) { return interval.count(0, d) % step === 0; });
      };
    }

    return interval;
  }

  var millisecond = newInterval(function() {
    // noop
  }, function(date, step) {
    date.setTime(+date + step);
  }, function(start, end) {
    return end - start;
  });

  // An optimized implementation for this simple case.
  millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return millisecond;
    return newInterval(function(date) {
      date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
      date.setTime(+date + step * k);
    }, function(start, end) {
      return (end - start) / k;
    });
  };

  var durationSecond = 1e3;
  var durationMinute = 6e4;
  var durationHour = 36e5;
  var durationDay = 864e5;
  var durationWeek = 6048e5;

  var second = newInterval(function(date) {
    date.setTime(Math.floor(date / durationSecond) * durationSecond);
  }, function(date, step) {
    date.setTime(+date + step * durationSecond);
  }, function(start, end) {
    return (end - start) / durationSecond;
  }, function(date) {
    return date.getUTCSeconds();
  });

  var minute = newInterval(function(date) {
    date.setTime(Math.floor(date / durationMinute) * durationMinute);
  }, function(date, step) {
    date.setTime(+date + step * durationMinute);
  }, function(start, end) {
    return (end - start) / durationMinute;
  }, function(date) {
    return date.getMinutes();
  });

  var hour = newInterval(function(date) {
    var offset = date.getTimezoneOffset() * durationMinute % durationHour;
    if (offset < 0) offset += durationHour;
    date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
  }, function(date, step) {
    date.setTime(+date + step * durationHour);
  }, function(start, end) {
    return (end - start) / durationHour;
  }, function(date) {
    return date.getHours();
  });

  var day = newInterval(function(date) {
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
  }, function(date) {
    return date.getDate() - 1;
  });

  function weekday(i) {
    return newInterval(function(date) {
      date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
      date.setHours(0, 0, 0, 0);
    }, function(date, step) {
      date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
      return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
    });
  }

  var sunday = weekday(0);
  var monday = weekday(1);
  var tuesday = weekday(2);
  var wednesday = weekday(3);
  var thursday = weekday(4);
  var friday = weekday(5);
  var saturday = weekday(6);

  var month = newInterval(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setMonth(date.getMonth() + step);
  }, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
  }, function(date) {
    return date.getMonth();
  });

  var year = newInterval(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
  }, function(start, end) {
    return end.getFullYear() - start.getFullYear();
  }, function(date) {
    return date.getFullYear();
  });

  // An optimized implementation for this simple case.
  year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
      date.setFullYear(Math.floor(date.getFullYear() / k) * k);
      date.setMonth(0, 1);
      date.setHours(0, 0, 0, 0);
    }, function(date, step) {
      date.setFullYear(date.getFullYear() + step * k);
    });
  };

  var utcMinute = newInterval(function(date) {
    date.setUTCSeconds(0, 0);
  }, function(date, step) {
    date.setTime(+date + step * durationMinute);
  }, function(start, end) {
    return (end - start) / durationMinute;
  }, function(date) {
    return date.getUTCMinutes();
  });

  var utcHour = newInterval(function(date) {
    date.setUTCMinutes(0, 0, 0);
  }, function(date, step) {
    date.setTime(+date + step * durationHour);
  }, function(start, end) {
    return (end - start) / durationHour;
  }, function(date) {
    return date.getUTCHours();
  });

  var utcDay = newInterval(function(date) {
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
  }, function(start, end) {
    return (end - start) / durationDay;
  }, function(date) {
    return date.getUTCDate() - 1;
  });

  function utcWeekday(i) {
    return newInterval(function(date) {
      date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
      date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
      date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
      return (end - start) / durationWeek;
    });
  }

  var utcSunday = utcWeekday(0);
  var utcMonday = utcWeekday(1);
  var utcTuesday = utcWeekday(2);
  var utcWednesday = utcWeekday(3);
  var utcThursday = utcWeekday(4);
  var utcFriday = utcWeekday(5);
  var utcSaturday = utcWeekday(6);

  var utcMonth = newInterval(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
  }, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
  }, function(date) {
    return date.getUTCMonth();
  });

  var utcYear = newInterval(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
  }, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
  }, function(date) {
    return date.getUTCFullYear();
  });

  // An optimized implementation for this simple case.
  utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
      date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
      date.setUTCMonth(0, 1);
      date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
      date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
  };

  function localDate(d) {
    if (0 <= d.y && d.y < 100) {
      var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
      date.setFullYear(d.y);
      return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
  }

  function utcDate(d) {
    if (0 <= d.y && d.y < 100) {
      var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
      date.setUTCFullYear(d.y);
      return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
  }

  function newYear(y) {
    return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
  }

  function formatLocale$1(locale) {
    var locale_dateTime = locale.dateTime,
        locale_date = locale.date,
        locale_time = locale.time,
        locale_periods = locale.periods,
        locale_weekdays = locale.days,
        locale_shortWeekdays = locale.shortDays,
        locale_months = locale.months,
        locale_shortMonths = locale.shortMonths;

    var periodRe = formatRe(locale_periods),
        periodLookup = formatLookup(locale_periods),
        weekdayRe = formatRe(locale_weekdays),
        weekdayLookup = formatLookup(locale_weekdays),
        shortWeekdayRe = formatRe(locale_shortWeekdays),
        shortWeekdayLookup = formatLookup(locale_shortWeekdays),
        monthRe = formatRe(locale_months),
        monthLookup = formatLookup(locale_months),
        shortMonthRe = formatRe(locale_shortMonths),
        shortMonthLookup = formatLookup(locale_shortMonths);

    var formats = {
      "a": formatShortWeekday,
      "A": formatWeekday,
      "b": formatShortMonth,
      "B": formatMonth,
      "c": null,
      "d": formatDayOfMonth,
      "e": formatDayOfMonth,
      "f": formatMicroseconds,
      "H": formatHour24,
      "I": formatHour12,
      "j": formatDayOfYear,
      "L": formatMilliseconds,
      "m": formatMonthNumber,
      "M": formatMinutes,
      "p": formatPeriod,
      "Q": formatUnixTimestamp,
      "s": formatUnixTimestampSeconds,
      "S": formatSeconds,
      "u": formatWeekdayNumberMonday,
      "U": formatWeekNumberSunday,
      "V": formatWeekNumberISO,
      "w": formatWeekdayNumberSunday,
      "W": formatWeekNumberMonday,
      "x": null,
      "X": null,
      "y": formatYear,
      "Y": formatFullYear,
      "Z": formatZone,
      "%": formatLiteralPercent
    };

    var utcFormats = {
      "a": formatUTCShortWeekday,
      "A": formatUTCWeekday,
      "b": formatUTCShortMonth,
      "B": formatUTCMonth,
      "c": null,
      "d": formatUTCDayOfMonth,
      "e": formatUTCDayOfMonth,
      "f": formatUTCMicroseconds,
      "H": formatUTCHour24,
      "I": formatUTCHour12,
      "j": formatUTCDayOfYear,
      "L": formatUTCMilliseconds,
      "m": formatUTCMonthNumber,
      "M": formatUTCMinutes,
      "p": formatUTCPeriod,
      "Q": formatUnixTimestamp,
      "s": formatUnixTimestampSeconds,
      "S": formatUTCSeconds,
      "u": formatUTCWeekdayNumberMonday,
      "U": formatUTCWeekNumberSunday,
      "V": formatUTCWeekNumberISO,
      "w": formatUTCWeekdayNumberSunday,
      "W": formatUTCWeekNumberMonday,
      "x": null,
      "X": null,
      "y": formatUTCYear,
      "Y": formatUTCFullYear,
      "Z": formatUTCZone,
      "%": formatLiteralPercent
    };

    var parses = {
      "a": parseShortWeekday,
      "A": parseWeekday,
      "b": parseShortMonth,
      "B": parseMonth,
      "c": parseLocaleDateTime,
      "d": parseDayOfMonth,
      "e": parseDayOfMonth,
      "f": parseMicroseconds,
      "H": parseHour24,
      "I": parseHour24,
      "j": parseDayOfYear,
      "L": parseMilliseconds,
      "m": parseMonthNumber,
      "M": parseMinutes,
      "p": parsePeriod,
      "Q": parseUnixTimestamp,
      "s": parseUnixTimestampSeconds,
      "S": parseSeconds,
      "u": parseWeekdayNumberMonday,
      "U": parseWeekNumberSunday,
      "V": parseWeekNumberISO,
      "w": parseWeekdayNumberSunday,
      "W": parseWeekNumberMonday,
      "x": parseLocaleDate,
      "X": parseLocaleTime,
      "y": parseYear,
      "Y": parseFullYear,
      "Z": parseZone,
      "%": parseLiteralPercent
    };

    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);

    function newFormat(specifier, formats) {
      return function(date) {
        var string = [],
            i = -1,
            j = 0,
            n = specifier.length,
            c,
            pad,
            format;

        if (!(date instanceof Date)) date = new Date(+date);

        while (++i < n) {
          if (specifier.charCodeAt(i) === 37) {
            string.push(specifier.slice(j, i));
            if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
            else pad = c === "e" ? " " : "0";
            if (format = formats[c]) c = format(date, pad);
            string.push(c);
            j = i + 1;
          }
        }

        string.push(specifier.slice(j, i));
        return string.join("");
      };
    }

    function newParse(specifier, newDate) {
      return function(string) {
        var d = newYear(1900),
            i = parseSpecifier(d, specifier, string += "", 0),
            week, day$$1;
        if (i != string.length) return null;

        // If a UNIX timestamp is specified, return it.
        if ("Q" in d) return new Date(d.Q);

        // The am-pm flag is 0 for AM, and 1 for PM.
        if ("p" in d) d.H = d.H % 12 + d.p * 12;

        // Convert day-of-week and week-of-year to day-of-year.
        if ("V" in d) {
          if (d.V < 1 || d.V > 53) return null;
          if (!("w" in d)) d.w = 1;
          if ("Z" in d) {
            week = utcDate(newYear(d.y)), day$$1 = week.getUTCDay();
            week = day$$1 > 4 || day$$1 === 0 ? utcMonday.ceil(week) : utcMonday(week);
            week = utcDay.offset(week, (d.V - 1) * 7);
            d.y = week.getUTCFullYear();
            d.m = week.getUTCMonth();
            d.d = week.getUTCDate() + (d.w + 6) % 7;
          } else {
            week = newDate(newYear(d.y)), day$$1 = week.getDay();
            week = day$$1 > 4 || day$$1 === 0 ? monday.ceil(week) : monday(week);
            week = day.offset(week, (d.V - 1) * 7);
            d.y = week.getFullYear();
            d.m = week.getMonth();
            d.d = week.getDate() + (d.w + 6) % 7;
          }
        } else if ("W" in d || "U" in d) {
          if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
          day$$1 = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
          d.m = 0;
          d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day$$1 + 5) % 7 : d.w + d.U * 7 - (day$$1 + 6) % 7;
        }

        // If a time zone is specified, all fields are interpreted as UTC and then
        // offset according to the specified time zone.
        if ("Z" in d) {
          d.H += d.Z / 100 | 0;
          d.M += d.Z % 100;
          return utcDate(d);
        }

        // Otherwise, all fields are in local time.
        return newDate(d);
      };
    }

    function parseSpecifier(d, specifier, string, j) {
      var i = 0,
          n = specifier.length,
          m = string.length,
          c,
          parse;

      while (i < n) {
        if (j >= m) return -1;
        c = specifier.charCodeAt(i++);
        if (c === 37) {
          c = specifier.charAt(i++);
          parse = parses[c in pads ? specifier.charAt(i++) : c];
          if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
        } else if (c != string.charCodeAt(j++)) {
          return -1;
        }
      }

      return j;
    }

    function parsePeriod(d, string, i) {
      var n = periodRe.exec(string.slice(i));
      return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }

    function parseShortWeekday(d, string, i) {
      var n = shortWeekdayRe.exec(string.slice(i));
      return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }

    function parseWeekday(d, string, i) {
      var n = weekdayRe.exec(string.slice(i));
      return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }

    function parseShortMonth(d, string, i) {
      var n = shortMonthRe.exec(string.slice(i));
      return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }

    function parseMonth(d, string, i) {
      var n = monthRe.exec(string.slice(i));
      return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }

    function parseLocaleDateTime(d, string, i) {
      return parseSpecifier(d, locale_dateTime, string, i);
    }

    function parseLocaleDate(d, string, i) {
      return parseSpecifier(d, locale_date, string, i);
    }

    function parseLocaleTime(d, string, i) {
      return parseSpecifier(d, locale_time, string, i);
    }

    function formatShortWeekday(d) {
      return locale_shortWeekdays[d.getDay()];
    }

    function formatWeekday(d) {
      return locale_weekdays[d.getDay()];
    }

    function formatShortMonth(d) {
      return locale_shortMonths[d.getMonth()];
    }

    function formatMonth(d) {
      return locale_months[d.getMonth()];
    }

    function formatPeriod(d) {
      return locale_periods[+(d.getHours() >= 12)];
    }

    function formatUTCShortWeekday(d) {
      return locale_shortWeekdays[d.getUTCDay()];
    }

    function formatUTCWeekday(d) {
      return locale_weekdays[d.getUTCDay()];
    }

    function formatUTCShortMonth(d) {
      return locale_shortMonths[d.getUTCMonth()];
    }

    function formatUTCMonth(d) {
      return locale_months[d.getUTCMonth()];
    }

    function formatUTCPeriod(d) {
      return locale_periods[+(d.getUTCHours() >= 12)];
    }

    return {
      format: function(specifier) {
        var f = newFormat(specifier += "", formats);
        f.toString = function() { return specifier; };
        return f;
      },
      parse: function(specifier) {
        var p = newParse(specifier += "", localDate);
        p.toString = function() { return specifier; };
        return p;
      },
      utcFormat: function(specifier) {
        var f = newFormat(specifier += "", utcFormats);
        f.toString = function() { return specifier; };
        return f;
      },
      utcParse: function(specifier) {
        var p = newParse(specifier, utcDate);
        p.toString = function() { return specifier; };
        return p;
      }
    };
  }

  var pads = {"-": "", "_": " ", "0": "0"},
      numberRe = /^\s*\d+/, // note: ignores next directive
      percentRe = /^%/,
      requoteRe = /[\\^$*+?|[\]().{}]/g;

  function pad(value, fill, width) {
    var sign = value < 0 ? "-" : "",
        string = (sign ? -value : value) + "",
        length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
  }

  function requote(s) {
    return s.replace(requoteRe, "\\$&");
  }

  function formatRe(names) {
    return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
  }

  function formatLookup(names) {
    var map = {}, i = -1, n = names.length;
    while (++i < n) map[names[i].toLowerCase()] = i;
    return map;
  }

  function parseWeekdayNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
  }

  function parseWeekdayNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
  }

  function parseWeekNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
  }

  function parseWeekNumberISO(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
  }

  function parseWeekNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
  }

  function parseFullYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
  }

  function parseYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
  }

  function parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
  }

  function parseMonthNumber(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
  }

  function parseDayOfMonth(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
  }

  function parseDayOfYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
  }

  function parseHour24(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
  }

  function parseMinutes(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
  }

  function parseSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
  }

  function parseMilliseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
  }

  function parseMicroseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
  }

  function parseLiteralPercent(d, string, i) {
    var n = percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
  }

  function parseUnixTimestamp(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
  }

  function parseUnixTimestampSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
  }

  function formatDayOfMonth(d, p) {
    return pad(d.getDate(), p, 2);
  }

  function formatHour24(d, p) {
    return pad(d.getHours(), p, 2);
  }

  function formatHour12(d, p) {
    return pad(d.getHours() % 12 || 12, p, 2);
  }

  function formatDayOfYear(d, p) {
    return pad(1 + day.count(year(d), d), p, 3);
  }

  function formatMilliseconds(d, p) {
    return pad(d.getMilliseconds(), p, 3);
  }

  function formatMicroseconds(d, p) {
    return formatMilliseconds(d, p) + "000";
  }

  function formatMonthNumber(d, p) {
    return pad(d.getMonth() + 1, p, 2);
  }

  function formatMinutes(d, p) {
    return pad(d.getMinutes(), p, 2);
  }

  function formatSeconds(d, p) {
    return pad(d.getSeconds(), p, 2);
  }

  function formatWeekdayNumberMonday(d) {
    var day$$1 = d.getDay();
    return day$$1 === 0 ? 7 : day$$1;
  }

  function formatWeekNumberSunday(d, p) {
    return pad(sunday.count(year(d), d), p, 2);
  }

  function formatWeekNumberISO(d, p) {
    var day$$1 = d.getDay();
    d = (day$$1 >= 4 || day$$1 === 0) ? thursday(d) : thursday.ceil(d);
    return pad(thursday.count(year(d), d) + (year(d).getDay() === 4), p, 2);
  }

  function formatWeekdayNumberSunday(d) {
    return d.getDay();
  }

  function formatWeekNumberMonday(d, p) {
    return pad(monday.count(year(d), d), p, 2);
  }

  function formatYear(d, p) {
    return pad(d.getFullYear() % 100, p, 2);
  }

  function formatFullYear(d, p) {
    return pad(d.getFullYear() % 10000, p, 4);
  }

  function formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+"))
        + pad(z / 60 | 0, "0", 2)
        + pad(z % 60, "0", 2);
  }

  function formatUTCDayOfMonth(d, p) {
    return pad(d.getUTCDate(), p, 2);
  }

  function formatUTCHour24(d, p) {
    return pad(d.getUTCHours(), p, 2);
  }

  function formatUTCHour12(d, p) {
    return pad(d.getUTCHours() % 12 || 12, p, 2);
  }

  function formatUTCDayOfYear(d, p) {
    return pad(1 + utcDay.count(utcYear(d), d), p, 3);
  }

  function formatUTCMilliseconds(d, p) {
    return pad(d.getUTCMilliseconds(), p, 3);
  }

  function formatUTCMicroseconds(d, p) {
    return formatUTCMilliseconds(d, p) + "000";
  }

  function formatUTCMonthNumber(d, p) {
    return pad(d.getUTCMonth() + 1, p, 2);
  }

  function formatUTCMinutes(d, p) {
    return pad(d.getUTCMinutes(), p, 2);
  }

  function formatUTCSeconds(d, p) {
    return pad(d.getUTCSeconds(), p, 2);
  }

  function formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
  }

  function formatUTCWeekNumberSunday(d, p) {
    return pad(utcSunday.count(utcYear(d), d), p, 2);
  }

  function formatUTCWeekNumberISO(d, p) {
    var day$$1 = d.getUTCDay();
    d = (day$$1 >= 4 || day$$1 === 0) ? utcThursday(d) : utcThursday.ceil(d);
    return pad(utcThursday.count(utcYear(d), d) + (utcYear(d).getUTCDay() === 4), p, 2);
  }

  function formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
  }

  function formatUTCWeekNumberMonday(d, p) {
    return pad(utcMonday.count(utcYear(d), d), p, 2);
  }

  function formatUTCYear(d, p) {
    return pad(d.getUTCFullYear() % 100, p, 2);
  }

  function formatUTCFullYear(d, p) {
    return pad(d.getUTCFullYear() % 10000, p, 4);
  }

  function formatUTCZone() {
    return "+0000";
  }

  function formatLiteralPercent() {
    return "%";
  }

  function formatUnixTimestamp(d) {
    return +d;
  }

  function formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
  }

  var locale$1;
  var timeFormat;
  var timeParse;
  var utcFormat;
  var utcParse;

  defaultLocale$1({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: ["AM", "PM"],
    days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  });

  function defaultLocale$1(definition) {
    locale$1 = formatLocale$1(definition);
    timeFormat = locale$1.format;
    timeParse = locale$1.parse;
    utcFormat = locale$1.utcFormat;
    utcParse = locale$1.utcParse;
    return locale$1;
  }

  var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

  function formatIsoNative(date) {
    return date.toISOString();
  }

  var formatIso = Date.prototype.toISOString
      ? formatIsoNative
      : utcFormat(isoSpecifier);

  function parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
  }

  var parseIso = +new Date("2000-01-01T00:00:00.000Z")
      ? parseIsoNative
      : utcParse(isoSpecifier);

  var initial_state = {
  	interacting: false
  };

  /*
  	Component: Surface
  	----------------------------------------

  	This low-level component will relay the user's coordinates
  	(via the Position component) in relation with the surface's bounds,
  	on the `onChange` callback. This callback will receive values 
  	for the X and Y coordinates in percentages (interval [0..100]).
  	
  */

  var Surface = function (_React$PureComponent) {
  	inherits(Surface, _React$PureComponent);

  	function Surface(props) {
  		classCallCheck(this, Surface);

  		// Bind event handlers
  		var _this = possibleConstructorReturn(this, (Surface.__proto__ || Object.getPrototypeOf(Surface)).call(this, props));

  		_this.register = _this.register.bind(_this);
  		_this.start = _this.start.bind(_this);
  		_this.end = _this.end.bind(_this);
  		_this.change = _this.change.bind(_this);
  		_this.insert = _this.insert.bind(_this);

  		_this.state = initial_state;

  		return _this;
  	}

  	createClass(Surface, [{
  		key: 'register',
  		value: function register(wrapper) {
  			this.wrapper = wrapper;
  		}
  	}, {
  		key: 'start',
  		value: function start(e) {
  			this.setState({
  				interacting: true
  			});
  			this.props.onStart(e);
  			this.change({
  				x: e.clientX,
  				y: e.clientY
  			});
  			e.stopPropagation();
  		}
  	}, {
  		key: 'end',
  		value: function end(e) {
  			this.setState({
  				interacting: false
  			});
  			this.props.onEnd(e);
  		}

  		// TODO `rect` could be cached at the beginning of the interaction 
  		// for better performance, but less reliability.
  		// (e.g. if the surface moves during the process)

  	}, {
  		key: 'scale',
  		value: function scale(_ref) {
  			var x = _ref.x,
  			    y = _ref.y;

  			if (this.wrapper) {
  				var rect = this.wrapper.getBoundingClientRect();
  				return {
  					x: this.props.x_scale.domain([rect.left, rect.right])(x),
  					y: this.props.y_scale.domain([rect.top, rect.bottom])(y)
  				};
  			}
  		}
  	}, {
  		key: 'change',
  		value: function change(coords) {
  			this.props.onChange(this.scale(coords), this.props.property);
  		}
  	}, {
  		key: 'insert',
  		value: function insert(e) {
  			this.props.onInsert(this.scale({
  				x: e.clientX,
  				y: e.clientY
  			}), this.props.property);
  		}
  	}, {
  		key: 'render',
  		value: function render() {
  			var _props = this.props,
  			    className = _props.className,
  			    passive = _props.passive;


  			var interacting = passive ? this.props.interacting : this.state.interacting;

  			var events = {};
  			if (passive) {
  				events['onDoubleClick'] = this.insert;
  			} else {
  				events['onMouseDownCapture'] = this.start;
  			}

  			return React.createElement(
  				'div',
  				_extends({
  					className: 'uix-surface ' + (className || ''),
  					ref: this.register
  				}, events),
  				interacting && React.createElement(Position, {
  					onChange: this.change,
  					onEnd: this.end
  				}),
  				this.props.children
  			);
  		}
  	}]);
  	return Surface;
  }(React.PureComponent);

  Surface.defaultProps = {
  	property: undefined,
  	className: undefined,
  	onStart: noop,
  	onEnd: noop,
  	onChange: noop,
  	onInsert: noop,
  	x_scale: linear$1().range([0, 100]).clamp(true),
  	y_scale: linear$1().range([0, 100]).clamp(true),
  	passive: false,
  	interacting: false
  };

  var scalePolar = function scalePolar(x, y) {
  	return {
  		r: Math.sqrt(x * x + y * y),
  		t: Math.atan2(y, x)
  	};
  };

  scalePolar.invert = function (r, t) {
  	return {
  		x: r * Math.cos(t),
  		y: r * Math.sin(t)
  	};
  };

  var PolarSurface = function (_React$PureComponent) {
  	inherits(PolarSurface, _React$PureComponent);

  	function PolarSurface(props) {
  		classCallCheck(this, PolarSurface);

  		var _this = possibleConstructorReturn(this, (PolarSurface.__proto__ || Object.getPrototypeOf(PolarSurface)).call(this, props));

  		_this.change = _this.change.bind(_this);
  		return _this;
  	}

  	createClass(PolarSurface, [{
  		key: 'change',
  		value: function change(_ref) {
  			var x = _ref.x,
  			    y = _ref.y;

  			var _scalePolar = scalePolar(x, y),
  			    r = _scalePolar.r,
  			    t = _scalePolar.t;

  			this.props.onChange({
  				r: Math.min(r, 50),
  				t: t
  			}, this.props.property);
  		}
  	}, {
  		key: 'render',
  		value: function render() {
  			return React.createElement(
  				Surface,
  				{
  					className: 'uix-surface--polar',
  					onChange: this.change,
  					onStart: this.props.onStart,
  					onEnd: this.props.onEnd,
  					x_scale: x_scale,
  					y_scale: y_scale,
  					passive: this.props.passive,
  					interacting: this.props.interacting,
  					property: this.props.property
  				},
  				this.props.children
  			);
  		}
  	}]);
  	return PolarSurface;
  }(React.PureComponent);

  var x_scale = linear$1().range([-50, 50]).clamp(true);
  var y_scale = linear$1().range([50, -50]).clamp(true);

  PolarSurface.defaultProps = {
  	onChange: noop,
  	onStart: undefined,
  	onEnd: undefined,
  	passive: false,
  	interacting: false,
  	property: undefined
  };

  var DeltaSurface = function (_React$Component) {
  	inherits(DeltaSurface, _React$Component);

  	function DeltaSurface(props) {
  		classCallCheck(this, DeltaSurface);

  		var _this = possibleConstructorReturn(this, (DeltaSurface.__proto__ || Object.getPrototypeOf(DeltaSurface)).call(this, props));

  		_this.start = _this.start.bind(_this);
  		_this.change = _this.change.bind(_this);
  		return _this;
  	}

  	createClass(DeltaSurface, [{
  		key: 'start',
  		value: function start(e) {
  			this._initial_x = e.clientX;
  			this._initial_y = e.clientY;
  			e.preventDefault();
  		}
  	}, {
  		key: 'change',
  		value: function change(_ref) {
  			var x = _ref.x,
  			    y = _ref.y;

  			this.props.onChange({
  				dx: x - this._initial_x,
  				dy: y - this._initial_y
  			});
  		}
  	}, {
  		key: 'render',
  		value: function render() {
  			return React.createElement(
  				Surface,
  				{
  					className: 'uix-surface--delta',
  					x_scale: scale_identity,
  					y_scale: scale_identity,
  					onStart: this.start,
  					onChange: this.change,
  					passive: this.props.passive,
  					interacting: this.props.interacting
  				},
  				this.props.children
  			);
  		}
  	}]);
  	return DeltaSurface;
  }(React.Component);

  var scale_identity = identity$4();

  DeltaSurface.defaultProps = {
  	onChange: noop,
  	passive: false,
  	interacting: false
  };

  var TextInput = function (_React$Component) {
  	inherits(TextInput, _React$Component);
  	createClass(TextInput, null, [{
  		key: 'getDerivedStateFromProps',
  		value: function getDerivedStateFromProps(props, current_state) {
  			if (props.value !== current_state.formatted_value) {
  				return {
  					value: props.value,
  					formatted_value: props.format(props.value),
  					transient_value: props.value
  				};
  			}
  			return null;
  		}
  	}]);

  	function TextInput(props) {
  		classCallCheck(this, TextInput);

  		var _this = possibleConstructorReturn(this, (TextInput.__proto__ || Object.getPrototypeOf(TextInput)).call(this, props));

  		_this.change = _this.change.bind(_this);
  		_this.handleKeys = _this.handleKeys.bind(_this);
  		_this.register = _this.register.bind(_this);
  		_this.commit = _this.commit.bind(_this);

  		_this.state = {};

  		return _this;
  	}

  	createClass(TextInput, [{
  		key: 'componentDidUpdate',
  		value: function componentDidUpdate(previous_props, previous_state) {
  			if (this.state.value === previous_state.value) {
  				return;
  			}
  			if (this.state.value !== this.props.value) {
  				this.props.onChange(this.state.value, this.props.property);
  			}
  		}
  	}, {
  		key: 'change',
  		value: function change(e) {
  			var input_value = e.target.value;
  			var state = { transient_value: input_value };
  			if (this.props.valid(input_value)) {
  				state['value'] = input_value;
  				state['formatted_value'] = this.props.format(input_value);
  			}
  			this.setState(state);
  		}
  	}, {
  		key: 'handleKeys',
  		value: function handleKeys(e) {
  			var handled = true;
  			switch (e.key) {
  				case 'Enter':
  					this.commit(e);
  					break;
  				case 'ArrowUp':
  					this.props.onNext(e);
  					break;
  				case 'ArrowDown':
  					this.props.onPrev(e);
  					break;
  				default:
  					handled = false;
  			}
  			if (handled) {
  				e.preventDefault();
  			}
  		}
  	}, {
  		key: 'commit',
  		value: function commit(e) {
  			var _this2 = this;

  			this.setState(function (current_state) {
  				return current_state.transient_value !== current_state.formatted_value ? { transient_value: current_state.formatted_value } : null;
  			}, function () {
  				return _this2.props.onEnd(e);
  			});
  		}
  	}, {
  		key: 'register',
  		value: function register(input) {
  			input && this.props.autofocus && input.focus();
  		}
  	}, {
  		key: 'render',
  		value: function render() {
  			var _props = this.props,
  			    className = _props.className,
  			    tabIndex = _props.tabIndex,
  			    title = _props.title;
  			var transient_value = this.state.transient_value;


  			return React.createElement(
  				'div',
  				{ className: 'uix-input ' + (className || '') },
  				React.createElement('input', {
  					tabIndex: tabIndex,
  					value: transient_value === undefined ? '' : transient_value,
  					onChange: this.change,
  					onKeyDown: this.handleKeys,
  					onFocus: this.props.onStart,
  					onBlur: this.commit,
  					ref: this.register,
  					title: title
  				}),
  				this.props.children
  			);
  		}
  	}]);
  	return TextInput;
  }(React.Component);

  TextInput.defaultProps = {

  	tabIndex: 0,
  	className: undefined,
  	autofocus: false,
  	property: undefined,

  	value: undefined,

  	onChange: noop,
  	onStart: noop,
  	onEnd: noop,
  	onPrev: noop,
  	onNext: noop,

  	valid: returnTrue,
  	format: identity

  };

  // See: https://github.com/d3/d3-format/issues/32
  var to_precision = function to_precision(value) {
  	var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  	return Math.round(value * (precision = Math.pow(10, precision))) / precision;
  };

  var to_step = function to_step(value, step) {
  	var precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  	var rounding = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'round';
  	return to_precision(Math[rounding](value / step) * step, precision);
  };

  var deg_to_radians = function deg_to_radians(deg) {
  	return deg * Math.PI / 180;
  };

  var clamp = function clamp(value, start, end) {
  	return Math.max(Math.min(value, Math.max(start, end)), Math.min(start, end));
  };

  var cycle = function cycle(value, start, end) {
  	var min = Math.min(start, end);
  	var max = Math.max(start, end);
  	return value < min ? max : value > max ? min : value;
  };

  var valid_float = function valid_float(value) {
  	var num = parseFloat((value + '').trim());
  	return !isNaN(num) && isFinite(num);
  };

  var initial_state$1 = {
  	increasing: false,
  	decreasing: false
  };

  var repeat_delay = 600; // milliseconds
  var repeat_interval = 50; // milliseconds

  var NumericInputControls = function (_React$PureComponent) {
  	inherits(NumericInputControls, _React$PureComponent);

  	function NumericInputControls(props) {
  		classCallCheck(this, NumericInputControls);

  		var _this = possibleConstructorReturn(this, (NumericInputControls.__proto__ || Object.getPrototypeOf(NumericInputControls)).call(this, props));

  		_this.startIncrease = _this.startIncrease.bind(_this);
  		_this.doIncrease = _this.doIncrease.bind(_this);
  		_this.stopIncrease = _this.stopIncrease.bind(_this);

  		_this.startDecrease = _this.startDecrease.bind(_this);
  		_this.doDecrease = _this.doDecrease.bind(_this);
  		_this.stopDecrease = _this.stopDecrease.bind(_this);

  		_this.state = initial_state$1;
  		return _this;
  	}

  	createClass(NumericInputControls, [{
  		key: 'startIncrease',
  		value: function startIncrease(e) {
  			var _this2 = this;

  			this.setState({
  				increasing: true
  			}, function () {
  				_this2.props.onStart(e);
  				_this2.doIncrease(repeat_delay);
  			});
  			e.preventDefault();
  		}
  	}, {
  		key: 'doIncrease',
  		value: function doIncrease() {
  			var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : repeat_interval;

  			if (this.state.increasing) {
  				this.props.increase();
  				window.setTimeout(this.doIncrease, timeout);
  			}
  		}
  	}, {
  		key: 'stopIncrease',
  		value: function stopIncrease(e) {
  			var _this3 = this;

  			this.setState({
  				increasing: false
  			}, function () {
  				_this3.props.onEnd(e);
  			});
  		}
  	}, {
  		key: 'startDecrease',
  		value: function startDecrease(e) {
  			var _this4 = this;

  			this.setState({
  				decreasing: true
  			}, function () {
  				_this4.props.onStart(e);
  				_this4.doDecrease(repeat_delay);
  			});
  			e.preventDefault();
  		}
  	}, {
  		key: 'doDecrease',
  		value: function doDecrease() {
  			var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : repeat_interval;

  			if (this.state.decreasing) {
  				this.props.decrease();
  				window.setTimeout(this.doDecrease, timeout);
  			}
  		}
  	}, {
  		key: 'stopDecrease',
  		value: function stopDecrease(e) {
  			var _this5 = this;

  			this.setState({
  				decreasing: false
  			}, function () {
  				_this5.props.onEnd(e);
  			});
  		}
  	}, {
  		key: 'render',
  		value: function render() {
  			var _state = this.state,
  			    increasing = _state.increasing,
  			    decreasing = _state.decreasing;


  			return React.createElement(
  				'span',
  				{ className: 'uix-input__controls' },
  				React.createElement(
  					'span',
  					{
  						className: 'uix-input__control uix-input__control--increment',
  						onMouseDown: this.startIncrease
  					},
  					React.createElement(
  						'svg',
  						{ viewBox: '0 0 20 9', className: 'uix-icon uix-icon--uparrow' },
  						React.createElement('path', { d: 'M 5 7 L 10 2 L 15 7' })
  					)
  				),
  				increasing && React.createElement(EventListener, {
  					target: 'document',
  					onMouseUp: this.stopIncrease
  				}),
  				React.createElement(
  					'span',
  					{
  						className: 'uix-input__control uix-input__control--decrement',
  						onMouseDown: this.startDecrease
  					},
  					React.createElement(
  						'svg',
  						{ viewBox: '0 0 20 9', className: 'uix-icon uix-icon--downarrow' },
  						React.createElement('path', { d: 'M 5 2 L 10 7 L 15 2' })
  					)
  				),
  				decreasing && React.createElement(EventListener, {
  					target: 'document',
  					onMouseUp: this.stopDecrease
  				})
  			);
  		}
  	}]);
  	return NumericInputControls;
  }(React.PureComponent);

  NumericInputControls.defaultProps = {
  	increase: noop,
  	decrease: noop,
  	onEnd: noop,
  	onStart: noop
  };

  var NumericInput = function (_React$PureComponent) {
  	inherits(NumericInput, _React$PureComponent);

  	function NumericInput(props) {
  		classCallCheck(this, NumericInput);

  		var _this = possibleConstructorReturn(this, (NumericInput.__proto__ || Object.getPrototypeOf(NumericInput)).call(this, props));

  		_this.change = _this.change.bind(_this);
  		_this.increase = _this.increase.bind(_this);
  		_this.decrease = _this.decrease.bind(_this);
  		_this.format_user_input = _this.format_user_input.bind(_this);

  		_this.state = {};
  		return _this;
  	}

  	createClass(NumericInput, [{
  		key: 'change',
  		value: function change(value) {
  			this.props.onChange(this.format_user_input(value), this.props.property);
  		}
  	}, {
  		key: 'format_user_input',
  		value: function format_user_input(value) {
  			return this.format_value(parseFloat(value));
  		}
  	}, {
  		key: 'format_value',
  		value: function format_value(value) {
  			var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : clamp;

  			return to_step(method(value, this.props.start, this.props.end), this.props.step, this.props.precision);
  		}
  	}, {
  		key: 'render',
  		value: function render() {
  			var _this2 = this;

  			var _props = this.props,
  			    autofocus = _props.autofocus,
  			    className = _props.className,
  			    tabIndex = _props.tabIndex,
  			    onStart = _props.onStart,
  			    onEnd = _props.onEnd,
  			    title = _props.title,
  			    value = _props.value;


  			return React.createElement(
  				TextInput,
  				{
  					className: 'uix-input--numeric ' + (className || ''),
  					tabIndex: tabIndex,
  					valid: valid_float,
  					format: this.format_user_input,
  					value: value,
  					onChange: this.change,
  					onPrev: this.decrease,
  					onNext: this.increase,
  					onStart: onStart,
  					onEnd: onEnd,
  					autofocus: autofocus,
  					title: title
  				},
  				React.Children.map(this.props.children, function (child) {
  					if (child.type === NumericInputControls) {
  						return React.cloneElement(child, {
  							increase: _this2.increase,
  							decrease: _this2.decrease,
  							start: onStart,
  							end: onEnd
  						});
  					}
  					return React.cloneElement(child);
  				})
  			);
  		}
  	}, {
  		key: 'increase',
  		value: function increase(e) {
  			this.offset(e, 1);
  		}
  	}, {
  		key: 'decrease',
  		value: function decrease(e) {
  			this.offset(e, -1);
  		}
  	}, {
  		key: 'offset',
  		value: function offset(e, dir) {
  			var amount = this.step_amount(e) * dir * Math.sign(this.props.end - this.props.start);
  			this.props.onChange(this.format_value((this.props.value !== undefined ? this.props.value : this.props.start) + amount, this.props.cyclical ? cycle : clamp), this.props.property);
  		}
  	}, {
  		key: 'step_amount',
  		value: function step_amount(e) {
  			return (typeof this.props.increment === 'function' ? this.props.increment(e) : this.props.increment) || this.props.step;
  		}
  	}]);
  	return NumericInput;
  }(React.PureComponent);

  NumericInput.defaultProps = {
  	tabIndex: 0,
  	className: undefined,
  	autofocus: false,
  	property: undefined,
  	cyclical: false,
  	step: 1,
  	precision: 0,
  	increment: function increment(e) {
  		return e ? e.shiftKey ? 10 : 1 : undefined;
  	},
  	start: 0,
  	end: 100,
  	value: undefined,
  	onChange: noop,
  	onStart: noop,
  	onEnd: noop
  };

  var simpleIsEqual = function simpleIsEqual(a, b) {
    return a === b;
  };

  function memoize (resultFn) {
    var isEqual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : simpleIsEqual;

    var lastThis = void 0;
    var lastArgs = [];
    var lastResult = void 0;
    var calledOnce = false;

    var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
      return isEqual(newArg, lastArgs[index]);
    };

    var result = function result() {
      for (var _len = arguments.length, newArgs = Array(_len), _key = 0; _key < _len; _key++) {
        newArgs[_key] = arguments[_key];
      }

      if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
        return lastResult;
      }

      calledOnce = true;
      lastThis = this;
      lastArgs = newArgs;
      lastResult = resultFn.apply(this, newArgs);
      return lastResult;
    };

    return result;
  }

  var initial_state$2 = {
  	x: undefined,
  	y: undefined,
  	interacting: false,
  	previous_props: {}
  };

  var scale = memoize(function (start, end) {
  	return linear$1().domain([0, 100]).range([start, end]).clamp(true);
  });

  var Pad = function (_React$PureComponent) {
  	inherits(Pad, _React$PureComponent);

  	function Pad(props) {
  		classCallCheck(this, Pad);

  		// Event handlers
  		var _this = possibleConstructorReturn(this, (Pad.__proto__ || Object.getPrototypeOf(Pad)).call(this, props));

  		_this.change = _this.change.bind(_this);
  		_this.keydown = _this.keydown.bind(_this);
  		_this.start = _this.start.bind(_this);
  		_this.end = _this.end.bind(_this);

  		// Initial state
  		_this.state = initial_state$2;
  		return _this;
  	}

  	createClass(Pad, [{
  		key: 'format_x',
  		value: function format_x(value) {
  			var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : clamp;

  			return value !== undefined ? to_step(method(value, this.props.x_start, this.props.x_end), this.props.x_step, this.props.x_precision) : undefined;
  		}
  	}, {
  		key: 'format_y',
  		value: function format_y(value) {
  			var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : clamp;

  			return value !== undefined ? to_step(method(value, this.props.y_start, this.props.y_end), this.props.y_step, this.props.y_precision) : undefined;
  		}
  	}, {
  		key: 'change',
  		value: function change(_ref) {
  			var x = _ref.x,
  			    y = _ref.y;

  			var x_val = this.format_x(scale(this.props.x_start, this.props.x_end)(x));
  			var y_val = this.format_y(scale(this.props.y_start, this.props.y_end)(y));
  			this.broadcast(x_val, y_val);
  		}
  	}, {
  		key: 'broadcast',
  		value: function broadcast(x, y) {
  			if (x !== this.props.x || y !== this.props.y) {
  				this.props.onChange({ x: x, y: y }, this.props.property);
  			}
  		}
  	}, {
  		key: 'start',
  		value: function start(e) {
  			var _this2 = this;

  			this.setState({
  				interacting: true
  			}, function () {
  				_this2.props.onStart(e);
  			});
  		}
  	}, {
  		key: 'end',
  		value: function end(e) {
  			var _this3 = this;

  			this.setState({
  				interacting: false
  			}, function () {
  				_this3.props.onEnd(e);
  			});
  		}
  	}, {
  		key: 'render',
  		value: function render() {
  			var _props = this.props,
  			    x = _props.x,
  			    y = _props.y,
  			    cyclical = _props.cyclical,
  			    tabIndex = _props.tabIndex,
  			    className = _props.className,
  			    x_step = _props.x_step,
  			    y_step = _props.y_step,
  			    x_precision = _props.x_precision,
  			    y_precision = _props.y_precision,
  			    x_start = _props.x_start,
  			    x_end = _props.x_end,
  			    y_start = _props.y_start,
  			    y_end = _props.y_end;
  			var interacting = this.state.interacting;


  			var x_scale = scale(x_start, x_end);
  			var y_scale = scale(y_start, y_end);

  			return React.createElement(
  				'div',
  				{
  					className: '\n\t\t\t\t\tuix-pad \n\t\t\t\t\t' + (cyclical ? 'uix-pad--cyclical' : '') + ' \n\t\t\t\t\t' + (interacting ? 'uix-pad--interacting' : '') + ' \n\t\t\t\t\t' + (className || '') + '\n\t\t\t\t',
  					tabIndex: tabIndex,
  					onKeyDown: this.keydown
  				},
  				React.createElement(
  					Surface,
  					{
  						onStart: this.start,
  						onEnd: this.end,
  						onChange: this.change
  					},
  					React.Children.map(this.props.children, function (child) {
  						return React.cloneElement(child, _extends({
  							x: x,
  							y: y,
  							x_scale: x_scale,
  							y_scale: y_scale,
  							x_step: x_step,
  							y_step: y_step,
  							x_precision: x_precision,
  							y_precision: y_precision,
  							interacting: interacting
  						}, child.props));
  					})
  				)
  			);
  		}
  	}, {
  		key: 'step_x_amount',
  		value: function step_x_amount(e) {
  			return (typeof this.props.x_increment === 'function' ? this.props.x_increment(e, this.props) : this.props.x_increment) || this.props.x_step;
  		}
  	}, {
  		key: 'step_y_amount',
  		value: function step_y_amount(e) {
  			return (typeof this.props.y_increment === 'function' ? this.props.y_increment(e, this.props) : this.props.y_increment) || this.props.y_step;
  		}
  	}, {
  		key: 'offset_x',
  		value: function offset_x(e, dir) {
  			var amount = this.step_x_amount(e) * dir * Math.sign(this.props.x_end - this.props.x_start);
  			this.broadcast(this.format_x((this.props.x === undefined ? this.props.x_start : this.props.x) + amount, this.props.cyclical ? cycle : clamp), this.props.y);
  		}
  	}, {
  		key: 'offset_y',
  		value: function offset_y(e, dir) {
  			var amount = this.step_y_amount(e) * dir * Math.sign(this.props.y_end - this.props.y_start);
  			this.broadcast(this.props.x, this.format_y((this.props.y === undefined ? this.props.y_start : this.props.y) + amount, this.props.cyclical ? cycle : clamp));
  		}
  	}, {
  		key: 'keydown',
  		value: function keydown(e) {
  			var handled = true;
  			switch (e.key) {
  				case 'ArrowUp':
  					this.offset_y(e, -1);
  					break;
  				case 'ArrowDown':
  					this.offset_y(e, 1);
  					break;
  				case 'ArrowLeft':
  					this.offset_x(e, -1);
  					break;
  				case 'ArrowRight':
  					this.offset_x(e, 1);
  					break;
  				default:
  					handled = false;
  			}
  			if (handled) {
  				e.preventDefault();
  			}
  		}
  	}]);
  	return Pad;
  }(React.PureComponent);

  Pad.defaultProps = {
  	property: undefined,
  	x_start: 0,
  	x_end: 100,
  	y_start: 0,
  	y_end: 100,
  	x_step: 1,
  	y_step: 1,
  	x_precision: 0,
  	y_precision: 0,
  	x_increment: undefined,
  	y_increment: undefined,
  	x: undefined,
  	y: undefined,
  	tabIndex: 0,
  	className: undefined,
  	cyclical: false,
  	onChange: noop,
  	onStart: noop,
  	onEnd: noop
  };

  var PadHandle = function (_React$PureComponent) {
  	inherits(PadHandle, _React$PureComponent);

  	function PadHandle() {
  		classCallCheck(this, PadHandle);
  		return possibleConstructorReturn(this, (PadHandle.__proto__ || Object.getPrototypeOf(PadHandle)).apply(this, arguments));
  	}

  	createClass(PadHandle, [{
  		key: 'render',
  		value: function render() {
  			var _props = this.props,
  			    x = _props.x,
  			    y = _props.y,
  			    x_scale = _props.x_scale,
  			    y_scale = _props.y_scale,
  			    interacting = _props.interacting,
  			    className = _props.className;


  			var style = {
  				left: x_scale.invert(x) + '%',
  				top: y_scale.invert(y) + '%'
  			};

  			return React.createElement('span', {
  				className: '\n\t\t\t\t\tuix-pad__handle \n\t\t\t\t\t' + (interacting ? 'uix-pad__handle--interacting' : '') + '\n\t\t\t\t\t' + (className || '') + '\n\t\t\t\t',
  				style: style
  			});
  		}
  	}]);
  	return PadHandle;
  }(React.PureComponent);

  PadHandle.defaultProps = {
  	className: undefined
  };

  var range$1 = (function (n) {
  	var arr = new Array(n),
  	    i = void 0;
  	for (i = 0; i < n; i++) {
  		arr[i] = i;
  	}return arr;
  });

  var PadGrid = function (_React$PureComponent) {
  	inherits(PadGrid, _React$PureComponent);

  	function PadGrid() {
  		classCallCheck(this, PadGrid);
  		return possibleConstructorReturn(this, (PadGrid.__proto__ || Object.getPrototypeOf(PadGrid)).apply(this, arguments));
  	}

  	createClass(PadGrid, [{
  		key: 'render',
  		value: function render() {
  			var _props = this.props,
  			    x_step = _props.x_step,
  			    y_step = _props.y_step,
  			    className = _props.className;


  			var width = 100;
  			var height = 100;

  			var x_steps = range$1(x_step ? Math.floor(width / x_step) : 0).slice(1);
  			var y_steps = range$1(y_step ? Math.floor(height / y_step) : 0).slice(1);

  			var x_path = x_steps.map(function (step) {
  				return 'M ' + step * x_step + ' 0 v ' + height;
  			}).join(' ');
  			var y_path = y_steps.map(function (step) {
  				return 'M 0 ' + step * y_step + ' h ' + width;
  			}).join(' ');

  			return React.createElement(
  				'svg',
  				{
  					className: '\n\t\t\t\t\tuix-pad__grid\n\t\t\t\t\t' + (className || '') + '\n\t\t\t\t',
  					viewBox: '0 0 ' + width + ' ' + height,
  					preserveAspectRatio: 'none'
  				},
  				React.createElement('rect', {
  					className: 'uix-pad__grid-background',
  					x: '0',
  					y: '0',
  					width: '100%',
  					height: '100%'
  				}),
  				React.createElement('path', {
  					className: 'uix-pad__grid-lines uix-pad__grid-lines--x',
  					d: x_path
  				}),
  				React.createElement('path', {
  					className: 'uix-pad__grid-lines uix-pad__grid-lines--y',
  					d: y_path
  				})
  			);
  		}
  	}]);
  	return PadGrid;
  }(React.PureComponent);

  var PadTooltip = function (_React$PureComponent) {
  	inherits(PadTooltip, _React$PureComponent);

  	function PadTooltip() {
  		classCallCheck(this, PadTooltip);
  		return possibleConstructorReturn(this, (PadTooltip.__proto__ || Object.getPrototypeOf(PadTooltip)).apply(this, arguments));
  	}

  	createClass(PadTooltip, [{
  		key: 'render',
  		value: function render() {
  			var _props = this.props,
  			    x = _props.x,
  			    y = _props.y,
  			    x_scale = _props.x_scale,
  			    y_scale = _props.y_scale,
  			    interacting = _props.interacting,
  			    className = _props.className,
  			    label = _props.label;


  			if (!interacting) {
  				return null;
  			}

  			var style = {
  				top: y_scale.invert(y) + '%',
  				left: x_scale.invert(x) + '%'
  			};

  			return React.createElement(
  				'span',
  				{
  					className: '\n\t\t\t\t\tuix-pad__tooltip ' + (className || '') + '\n\t\t\t\t',
  					style: style
  				},
  				label(x, y)
  			);
  		}
  	}]);
  	return PadTooltip;
  }(React.PureComponent);

  PadTooltip.defaultProps = {
  	label: function label(x, y) {
  		return x + ':' + y;
  	}
  };

  var r_scale = memoize(function (start, end) {
  	return linear$1().domain([0, 50]).range([start, end]).clamp(true);
  });

  var t_scale = memoize(function (start, end) {
  	return linear$1().domain([-Math.PI, Math.PI]).range([start, end]).clamp(true);
  });

  var initial_state$3 = {
  	interacting: false
  };

  var PolarPad = function (_React$PureComponent) {
  	inherits(PolarPad, _React$PureComponent);

  	function PolarPad(props) {
  		classCallCheck(this, PolarPad);

  		var _this = possibleConstructorReturn(this, (PolarPad.__proto__ || Object.getPrototypeOf(PolarPad)).call(this, props));

  		_this.onChange = _this.onChange.bind(_this);
  		_this.onStart = _this.onStart.bind(_this);
  		_this.onEnd = _this.onEnd.bind(_this);

  		_this.state = initial_state$3;

  		return _this;
  	}

  	createClass(PolarPad, [{
  		key: 'onStart',
  		value: function onStart() {
  			this.setState({
  				interacting: true
  			});
  		}
  	}, {
  		key: 'onEnd',
  		value: function onEnd() {
  			this.setState({
  				interacting: false
  			});
  		}
  	}, {
  		key: 'onChange',
  		value: function onChange(_ref) {
  			var r = _ref.r,
  			    t = _ref.t;


  			var r_val = to_step(r_scale(this.props.r_start, this.props.r_end)(r), this.props.r_step, this.props.r_precision);
  			var t_val = to_step(t_scale(this.props.t_start, this.props.t_end)(t), this.props.t_step, this.props.t_precision);

  			// don't update state with the same values
  			if (r_val === this.props.r && t_val === this.props.t) {
  				return;
  			}

  			this.props.onChange({
  				r: r_val,
  				t: t_val
  			}, this.props.property);
  		}
  	}, {
  		key: 'render',
  		value: function render() {
  			var _this2 = this;

  			var interacting = this.state.interacting;
  			var _props = this.props,
  			    r = _props.r,
  			    t = _props.t,
  			    r_step = _props.r_step,
  			    t_step = _props.t_step;


  			return React.createElement(
  				'div',
  				{ className: 'uix-polarpad' },
  				React.createElement(
  					PolarSurface,
  					{
  						onChange: this.onChange,
  						onStart: this.onStart,
  						onEnd: this.onEnd
  					},
  					React.Children.map(this.props.children, function (child) {
  						return React.cloneElement(child, _extends({
  							r: r,
  							t: t,
  							r_scale: r_scale(_this2.props.r_start, _this2.props.r_end),
  							t_scale: t_scale(_this2.props.t_start, _this2.props.t_end),
  							r_step: r_step,
  							t_step: t_step,
  							interacting: interacting

  						}, child.props));
  					})
  				)
  			);
  		}
  	}]);
  	return PolarPad;
  }(React.PureComponent);

  PolarPad.defaultProps = {
  	r: 0,
  	r_start: 0,
  	r_end: 100,
  	t_start: -180,
  	t_end: 180,
  	r_step: 1,
  	r_precision: 0,
  	t_step: 1,
  	t_precision: 0,
  	t: 0,
  	onChange: noop,
  	property: undefined
  };

  var PolarPadHandle = function (_React$Component) {
  	inherits(PolarPadHandle, _React$Component);

  	function PolarPadHandle() {
  		classCallCheck(this, PolarPadHandle);
  		return possibleConstructorReturn(this, (PolarPadHandle.__proto__ || Object.getPrototypeOf(PolarPadHandle)).apply(this, arguments));
  	}

  	createClass(PolarPadHandle, [{
  		key: 'render',
  		value: function render() {
  			var _props = this.props,
  			    r = _props.r,
  			    t = _props.t,
  			    r_scale = _props.r_scale,
  			    t_scale = _props.t_scale,
  			    interacting = _props.interacting;

  			var _scalePolar$invert = scalePolar.invert(r_scale.invert(r), t_scale.invert(t)),
  			    x = _scalePolar$invert.x,
  			    y = _scalePolar$invert.y;

  			var handle_styles = {
  				left: x + 50 + '%',
  				top: 50 - y + '%'
  			};

  			return React.createElement('div', {
  				className: 'uix-polarpad__handle',
  				style: handle_styles
  			});
  		}
  	}]);
  	return PolarPadHandle;
  }(React.Component);

  PolarPadHandle.defaultProps = {};

  var arc_from_circle = function arc_from_circle(cx, cy, r) {
  	return "\n\tM " + cx + " " + cy + "\n\tm " + -r + " 0\n\ta " + r + " " + r + " 0 1 1 " + r * 2 + " 0\n\ta " + r + " " + r + " 0 1 1 " + -r * 2 + " 0\n";
  };

  var PolarPadGrid = function (_React$PureComponent) {
  	inherits(PolarPadGrid, _React$PureComponent);

  	function PolarPadGrid() {
  		classCallCheck(this, PolarPadGrid);
  		return possibleConstructorReturn(this, (PolarPadGrid.__proto__ || Object.getPrototypeOf(PolarPadGrid)).apply(this, arguments));
  	}

  	createClass(PolarPadGrid, [{
  		key: 'render',
  		value: function render() {
  			var _props = this.props,
  			    r_step = _props.r_step,
  			    t_step = _props.t_step;


  			var size = 100;
  			var angle = 360;
  			var cx = size / 2;
  			var cy = size / 2;
  			var r = size / 2;

  			var r_steps = range$1(r_step ? Math.floor(size / r_step) : 0).slice(1);
  			var t_steps = range$1(t_step ? Math.floor(angle / t_step) : 0);

  			var r_path = r_steps.map(function (step) {
  				return arc_from_circle(cx, cy, step * r_step / 2);
  			}).join(' ');
  			var t_path = t_steps.map(function (step) {
  				return '\n\t\t\tM \n\t\t\t\t' + (cx + r_step / 2 * Math.cos(deg_to_radians(step * t_step))) + ' \n\t\t\t\t' + (cy + r_step / 2 * Math.sin(deg_to_radians(step * t_step))) + '\n\t\t\tl \n\t\t\t\t' + (r - r_step / 2) * Math.cos(deg_to_radians(step * t_step)) + ' \n\t\t\t\t' + (r - r_step / 2) * Math.sin(deg_to_radians(step * t_step)) + '\n\t\t';
  			}).join(' ');

  			return React.createElement(
  				'svg',
  				{ className: 'uix-polarpad__grid', viewBox: '0 0 ' + size + ' ' + size },
  				React.createElement('rect', {
  					className: 'uix-polarpad__grid-background',
  					x: '0',
  					y: '0',
  					width: '100%',
  					height: '100%'
  				}),
  				React.createElement('path', {
  					className: 'uix-polarpad__grid-lines uix-polarpad__grid-lines--r',
  					d: r_path
  				}),
  				React.createElement('path', {
  					className: 'uix-polarpad__grid-lines uix-polarpad__grid-lines--t',
  					d: t_path
  				})
  			);
  		}
  	}]);
  	return PolarPadGrid;
  }(React.PureComponent);

  var initial_state$4 = {
  	interacting: false
  };

  var Slider = function (_React$Component) {
  	inherits(Slider, _React$Component);

  	function Slider(props) {
  		classCallCheck(this, Slider);

  		// Event handlers
  		var _this = possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

  		_this.change = _this.change.bind(_this);
  		_this.start = _this.start.bind(_this);
  		_this.end = _this.end.bind(_this);

  		// Initial state
  		_this.state = initial_state$4;
  		return _this;
  	}

  	createClass(Slider, [{
  		key: 'change',
  		value: function change(_ref) {
  			var x = _ref.x,
  			    y = _ref.y;

  			var value = this.props.vertical ? y : x;
  			if (value !== this.props.value) {
  				this.props.onChange(value, this.props.property);
  			}
  		}
  	}, {
  		key: 'start',
  		value: function start(e) {
  			var _this2 = this;

  			this.setState({
  				interacting: true
  			}, function () {
  				_this2.props.onStart(e);
  			});
  		}
  	}, {
  		key: 'end',
  		value: function end(e) {
  			var _this3 = this;

  			this.setState({
  				interacting: false
  			}, function () {
  				_this3.props.onEnd(e);
  			});
  		}
  	}, {
  		key: 'render',
  		value: function render() {
  			var _props = this.props,
  			    vertical = _props.vertical,
  			    cyclical = _props.cyclical,
  			    tabIndex = _props.tabIndex,
  			    className = _props.className,
  			    step = _props.step,
  			    precision = _props.precision,
  			    start = _props.start,
  			    end = _props.end,
  			    increment = _props.increment,
  			    property = _props.property,
  			    value = _props.value;
  			var interacting = this.state.interacting;


  			var pad_props = vertical ? {
  				y: value,
  				y_start: end,
  				y_end: start,
  				y_step: step,
  				y_precision: precision,
  				y_increment: increment
  			} : {
  				x: value,
  				x_start: start,
  				x_end: end,
  				x_step: step,
  				x_precision: precision,
  				x_increment: increment
  			};

  			return React.createElement(
  				'div',
  				{
  					className: '\n\t\t\t\t\tuix-slider \n\t\t\t\t\t' + (vertical ? 'uix-slider--vertical' : '') + ' \n\t\t\t\t\t' + (cyclical ? 'uix-slider--cyclical' : '') + ' \n\t\t\t\t\t' + (interacting ? 'uix-slider--interacting' : '') + ' \n\t\t\t\t\t' + (className || '') + '\n\t\t\t\t',
  					tabIndex: tabIndex,
  					onKeyDown: this.keydown
  				},
  				React.createElement(
  					Pad,
  					_extends({
  						onStart: this.start,
  						onChange: this.change,
  						onEnd: this.end,
  						property: property,
  						cyclical: cyclical
  					}, pad_props),
  					React.Children.map(this.props.children, function (child) {
  						return React.cloneElement(child, {
  							vertical: vertical
  						});
  					})
  				)
  			);
  		}
  	}]);
  	return Slider;
  }(React.Component);

  Slider.defaultProps = {

  	className: undefined,
  	property: undefined,
  	tabIndex: 0,

  	vertical: false,
  	cyclical: false,

  	value: undefined,
  	start: 0,
  	end: 100,
  	step: 1,
  	precision: 0,
  	increment: undefined,

  	onChange: noop,
  	onStart: noop,
  	onEnd: noop

  };

  var SliderHandle = function (_React$PureComponent) {
  	inherits(SliderHandle, _React$PureComponent);

  	function SliderHandle() {
  		classCallCheck(this, SliderHandle);
  		return possibleConstructorReturn(this, (SliderHandle.__proto__ || Object.getPrototypeOf(SliderHandle)).apply(this, arguments));
  	}

  	createClass(SliderHandle, [{
  		key: 'render',
  		value: function render() {
  			var slider_props = defineProperty({}, this.props.vertical ? 'x' : 'y', 50);
  			return React.createElement(PadHandle, _extends({
  				className: '\n\t\t\t\t\tuix-slider__handle\n\t\t\t\t\t' + (this.props.interacting ? 'uix-slider__handle--interacting' : '') + '\n\t\t\t\t'
  			}, this.props, slider_props));
  		}
  	}]);
  	return SliderHandle;
  }(React.PureComponent);

  var SliderProgress = function (_React$PureComponent) {
  	inherits(SliderProgress, _React$PureComponent);

  	function SliderProgress() {
  		classCallCheck(this, SliderProgress);
  		return possibleConstructorReturn(this, (SliderProgress.__proto__ || Object.getPrototypeOf(SliderProgress)).apply(this, arguments));
  	}

  	createClass(SliderProgress, [{
  		key: 'render',
  		value: function render() {
  			var _props = this.props,
  			    x = _props.x,
  			    y = _props.y,
  			    x_scale = _props.x_scale,
  			    y_scale = _props.y_scale,
  			    vertical = _props.vertical,
  			    interacting = _props.interacting;


  			var style = {};
  			if (vertical) {
  				style['height'] = 100 - y_scale.invert(y) + '%';
  			} else {
  				style['width'] = x_scale.invert(x) + '%';
  			}

  			return React.createElement('span', {
  				className: '\n\t\t\t\t\tuix-slider__progress \n\t\t\t\t\t' + (interacting ? 'uix-slider__progress--interacting' : '') + '\n\t\t\t\t',
  				style: style
  			});
  		}
  	}]);
  	return SliderProgress;
  }(React.PureComponent);

  var show_x = function show_x(x, y) {
  	return x;
  };
  var show_y = function show_y(x, y) {
  	return y;
  };

  var SliderTooltip = function (_React$PureComponent) {
  	inherits(SliderTooltip, _React$PureComponent);

  	function SliderTooltip() {
  		classCallCheck(this, SliderTooltip);
  		return possibleConstructorReturn(this, (SliderTooltip.__proto__ || Object.getPrototypeOf(SliderTooltip)).apply(this, arguments));
  	}

  	createClass(SliderTooltip, [{
  		key: 'render',
  		value: function render() {
  			var _slider_props;

  			var slider_props = (_slider_props = {}, defineProperty(_slider_props, this.props.vertical ? 'x' : 'y', 50), defineProperty(_slider_props, 'label', this.props.vertical ? show_y : show_x), _slider_props);

  			return React.createElement(PadTooltip, _extends({
  				className: 'uix-slider__tooltip'
  			}, this.props, slider_props));
  		}
  	}]);
  	return SliderTooltip;
  }(React.PureComponent);

  var SliderGrid = function (_React$PureComponent) {
  	inherits(SliderGrid, _React$PureComponent);

  	function SliderGrid() {
  		classCallCheck(this, SliderGrid);
  		return possibleConstructorReturn(this, (SliderGrid.__proto__ || Object.getPrototypeOf(SliderGrid)).apply(this, arguments));
  	}

  	createClass(SliderGrid, [{
  		key: 'render',
  		value: function render() {
  			var _props = this.props,
  			    x_step = _props.x_step,
  			    y_step = _props.y_step,
  			    vertical = _props.vertical;


  			var slider_props = defineProperty({}, vertical ? 'x_step' : 'y_step', 0);

  			return React.createElement(PadGrid, _extends({
  				className: '\n\t\t\t\tuix-slider__grid\n\t\t\t\t' + (this.props.interacting ? 'uix-slider__grid--interacting' : '') + '\n\t\t\t'
  			}, this.props, slider_props));
  		}
  	}]);
  	return SliderGrid;
  }(React.PureComponent);

  var List = function (_React$Component) {
  	inherits(List, _React$Component);

  	function List(props) {
  		classCallCheck(this, List);

  		var _this = possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

  		_this.select = _this.select.bind(_this);
  		return _this;
  	}

  	createClass(List, [{
  		key: 'select',
  		value: function select(value) {
  			this.props.onSelect(value, this.props.property);
  			if (value !== this.props.value) {
  				this.props.onChange(value, this.props.property);
  			}
  		}
  	}, {
  		key: 'render',
  		value: function render() {
  			var _this2 = this;

  			var _props = this.props,
  			    value = _props.value,
  			    tabIndex = _props.tabIndex,
  			    className = _props.className;


  			return React.createElement(
  				'ul',
  				{
  					className: 'uix-list ' + (className || ''),
  					tabIndex: tabIndex
  				},
  				React.Children.map(this.props.children, function (child) {
  					return React.cloneElement(child, {
  						onSelect: _this2.select,
  						tabIndex: tabIndex,
  						selected: value === child.props.value
  					});
  				})
  			);
  		}
  	}]);
  	return List;
  }(React.Component);

  List.defaultProps = {
  	tabIndex: '0',
  	className: undefined,
  	property: undefined,
  	value: undefined,
  	onChange: noop,
  	onSelect: noop
  };

  var ListItem = function (_React$PureComponent) {
  	inherits(ListItem, _React$PureComponent);

  	function ListItem(props) {
  		classCallCheck(this, ListItem);

  		var _this = possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call(this, props));

  		_this.select = _this.select.bind(_this);
  		_this.keydown = _this.keydown.bind(_this);
  		return _this;
  	}

  	createClass(ListItem, [{
  		key: 'select',
  		value: function select() {
  			this.props.onSelect(this.props.value);
  		}
  	}, {
  		key: 'keydown',
  		value: function keydown(e) {
  			if (e.key === 'Enter') {
  				this.select();
  				e.preventDefault();
  				e.stopPropagation();
  			}
  		}
  	}, {
  		key: 'render',
  		value: function render() {
  			var _props = this.props,
  			    selected = _props.selected,
  			    tabIndex = _props.tabIndex,
  			    className = _props.className,
  			    title = _props.title;


  			return React.createElement(
  				'li',
  				{
  					tabIndex: tabIndex,
  					className: 'uix-list__item ' + (selected ? 'uix-list__item--selected' : '') + '  ' + (className || ''),
  					onMouseUp: this.select,
  					onKeyDown: this.keydown
  				},
  				this.props.children
  			);
  		}
  	}]);
  	return ListItem;
  }(React.PureComponent);

  ListItem.defaultProps = {
  	value: null,
  	selected: false,
  	onSelect: noop,
  	className: undefined
  };

  var Popup = function (_React$Component) {
  	inherits(Popup, _React$Component);

  	function Popup(props) {
  		classCallCheck(this, Popup);

  		var _this = possibleConstructorReturn(this, (Popup.__proto__ || Object.getPrototypeOf(Popup)).call(this, props));

  		_this.close = _this.close.bind(_this);
  		_this.close_on_click_outside = _this.close_on_click_outside.bind(_this);
  		_this.register = _this.register.bind(_this);
  		return _this;
  	}

  	createClass(Popup, [{
  		key: 'close',
  		value: function close(e) {
  			this.props.onClose(this.props.property);
  		}
  	}, {
  		key: 'close_on_click_outside',
  		value: function close_on_click_outside(e) {
  			if (!this._el || this._el === e.target || this._el.contains(e.target)) {
  				return;
  			}
  			this.close(e);
  		}
  	}, {
  		key: 'register',
  		value: function register(el) {
  			this._el = el;
  			if (el && this.props.autofocus) {
  				el.focus();
  			}
  		}
  	}, {
  		key: 'render',
  		value: function render() {
  			var _props = this.props,
  			    className = _props.className,
  			    tabIndex = _props.tabIndex;


  			return React.createElement(
  				'div',
  				{
  					className: '\n\t\t\t\t\tuix-popup\n\t\t\t\t\t' + (className || '') + ' \n\t\t\t\t',
  					tabIndex: tabIndex,
  					ref: this.register
  				},
  				React.createElement(EventListener, {
  					target: 'document',
  					onMouseDown: this.close_on_click_outside
  				}),
  				typeof this.props.children === 'function' ? this.props.children(this.close) : this.props.children
  			);
  		}
  	}]);
  	return Popup;
  }(React.Component);

  Popup.defaultProps = {
  	tabIndex: 0,
  	className: undefined,
  	property: undefined,
  	autofocus: false,
  	onClose: noop
  };

  var initial_state$5 = {
  	rect: {}
  };

  var Portal = function (_React$Component) {
  	inherits(Portal, _React$Component);

  	function Portal(props) {
  		classCallCheck(this, Portal);

  		var _this = possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this, props));

  		_this.register = _this.register.bind(_this);
  		_this.state = initial_state$5;
  		return _this;
  	}

  	createClass(Portal, [{
  		key: 'register',
  		value: function register(el) {
  			this.el = el;
  			if (el) {
  				var ref = this.props.mirror;
  				if (ref) {
  					var rect = (typeof ref === 'function' ? ref() : ref).getBoundingClientRect();
  					this.setState({
  						rect: rect
  					});
  				}
  			}
  		}
  	}, {
  		key: 'render',
  		value: function render() {
  			var _props = this.props,
  			    target = _props.target,
  			    mirror = _props.mirror,
  			    className = _props.className;
  			var rect = this.state.rect;


  			if (target) {
  				return ReactDOM.createPortal(React.createElement(
  					'div',
  					{
  						className: '\n\t\t\t\t\t\tuix-portal\n\t\t\t\t\t\t' + (className || '') + ' \n\t\t\t\t\t',
  						style: {
  							left: rect.left + 'px',
  							top: rect.top + 'px',
  							width: rect.width + 'px',
  							height: rect.height + 'px'
  						},
  						ref: this.register
  					},
  					this.props.children
  				), target);
  			} else {
  				return this.props.children;
  			}
  		}
  	}]);
  	return Portal;
  }(React.Component);

  Portal.defaultProps = {
  	className: undefined,
  	target: undefined,
  	mirror: undefined
  };

  var Select = function (_React$Component) {
  	inherits(Select, _React$Component);

  	function Select(props) {
  		classCallCheck(this, Select);

  		var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

  		_this.select = _this.select.bind(_this);
  		_this.focus = _this.focus.bind(_this);
  		_this.register = _this.register.bind(_this);
  		_this.handleKeys = _this.handleKeys.bind(_this);
  		_this.open = _this.open.bind(_this);
  		_this.close = _this.close.bind(_this);

  		_this.state = {
  			interacting: false
  		};
  		return _this;
  	}

  	createClass(Select, [{
  		key: 'select',
  		value: function select(value) {
  			this.close();
  			this.focus();
  			if (value !== this.props.value) {
  				this.props.onChange(value, this.props.property);
  			}
  		}
  	}, {
  		key: 'open',
  		value: function open() {
  			this.setState({
  				interacting: true
  			});
  		}
  	}, {
  		key: 'close',
  		value: function close() {
  			this.setState({
  				interacting: false
  			});
  		}
  	}, {
  		key: 'focus',
  		value: function focus() {
  			if (this.element) {
  				this.element.focus();
  			}
  		}
  	}, {
  		key: 'register',
  		value: function register(el) {
  			this.element = el;
  		}
  	}, {
  		key: 'handleKeys',
  		value: function handleKeys(e) {
  			switch (e.key) {
  				case 'Enter':
  					this.open(e);
  					break;
  			}
  		}
  	}, {
  		key: 'render',
  		value: function render() {
  			var _this2 = this;

  			var _props = this.props,
  			    className = _props.className,
  			    tabIndex = _props.tabIndex,
  			    target = _props.target;
  			var _state = this.state,
  			    interacting = _state.interacting,
  			    wrapper = _state.wrapper;


  			return React.createElement(
  				'div',
  				{
  					className: '\n\t\t\t\t\tuix-select\n\t\t\t\t\t' + (className || '') + '\n\t\t\t\t\t' + (target ? 'uix-select--portal' : '') + '\n\t\t\t\t',
  					ref: this.register,
  					tabIndex: tabIndex,
  					onKeyDown: this.handleKeys
  				},
  				React.createElement(
  					'div',
  					{
  						className: 'uix-select__current',
  						onMouseDown: this.open
  					},
  					React.createElement(
  						'div',
  						{ className: 'uix-select__value' },
  						this.props.current(this.props.value)
  					),
  					React.createElement(
  						'div',
  						{ className: 'uix-select__button' },
  						React.createElement(
  							'button',
  							{ tabIndex: '-1' },
  							'\u2193'
  						)
  					)
  				),
  				interacting && React.createElement(
  					Portal,
  					{
  						target: target,
  						mirror: this.element
  					},
  					React.createElement(
  						Popup,
  						{
  							autofocus: true,
  							onClose: this.close,
  							className: ' \n\t\t\t\t\t\t\t\t\tuix-select__popup\n\t\t\t\t\t\t\t\t\t' + (target ? 'uix-select__popup--portal' : '') + '\n\t\t\t\t\t\t\t\t'
  						},
  						function (close) {
  							return React.Children.map(_this2.props.children, function (child) {
  								return React.cloneElement(child, {
  									className: '\n\t\t\t\t\t\t\t\t\t\t\t\t\t' + (child.props.className || "") + '\n\t\t\t\t\t\t\t\t\t\t\t\t\tuix-select__popup-content\n\t\t\t\t\t\t\t\t\t\t\t\t',
  									value: _this2.props.value,
  									onSelect: _this2.select
  								});
  							});
  						}
  					)
  				)
  			);
  		}
  	}]);
  	return Select;
  }(React.Component);

  Select.defaultProps = {
  	tabIndex: 0,
  	property: undefined,
  	className: undefined,
  	value: undefined,
  	onChange: noop,
  	target: undefined
  };

  var initial_state$6 = {
  	interacting: false
  };

  var MultiSlider = function (_React$Component) {
  	inherits(MultiSlider, _React$Component);

  	function MultiSlider(props) {
  		classCallCheck(this, MultiSlider);

  		var _this = possibleConstructorReturn(this, (MultiSlider.__proto__ || Object.getPrototypeOf(MultiSlider)).call(this, props));

  		_this.onStart = _this.onStart.bind(_this);
  		_this.onEnd = _this.onEnd.bind(_this);
  		_this.onChange = _this.onChange.bind(_this);
  		_this.onInsert = _this.onInsert.bind(_this);
  		_this.state = initial_state$6;
  		return _this;
  	}

  	createClass(MultiSlider, [{
  		key: 'onStart',
  		value: function onStart(e, property) {
  			this.setState({
  				interacting: true,
  				interacting_property: property
  			});
  		}
  	}, {
  		key: 'onEnd',
  		value: function onEnd(e) {
  			this.setState({
  				interacting: false,
  				interacting_property: null
  			});
  		}
  	}, {
  		key: 'onChange',
  		value: function onChange(_ref) {
  			var x = _ref.x,
  			    y = _ref.y;

  			this.props.onChange(x, this.state.interacting_property);
  		}
  	}, {
  		key: 'onInsert',
  		value: function onInsert(_ref2) {
  			var x = _ref2.x,
  			    y = _ref2.y;

  			this.props.onInsert(x);
  		}
  	}, {
  		key: 'render',
  		value: function render() {
  			var _this2 = this;

  			var interacting = this.state.interacting;


  			return React.createElement(
  				'div',
  				{ className: 'uix-multislider' },
  				React.createElement(
  					Surface,
  					{
  						passive: true,
  						interacting: interacting,
  						onChange: this.onChange,
  						onInsert: this.onInsert,
  						onEnd: this.onEnd
  					},
  					React.Children.map(this.props.children, function (child) {
  						return React.cloneElement(child, {
  							onStart: _this2.onStart
  						});
  					})
  				)
  			);
  		}
  	}]);
  	return MultiSlider;
  }(React.Component);

  MultiSlider.defaultProps = {
  	onChange: noop,
  	onInsert: noop
  };

  var MultiSliderHandle = function (_React$PureComponent) {
  	inherits(MultiSliderHandle, _React$PureComponent);

  	function MultiSliderHandle(props) {
  		classCallCheck(this, MultiSliderHandle);

  		var _this = possibleConstructorReturn(this, (MultiSliderHandle.__proto__ || Object.getPrototypeOf(MultiSliderHandle)).call(this, props));

  		_this.startInteraction = _this.startInteraction.bind(_this);
  		return _this;
  	}

  	createClass(MultiSliderHandle, [{
  		key: 'startInteraction',
  		value: function startInteraction(e) {
  			this.props.onStart(e, this.props.property);
  		}
  	}, {
  		key: 'render',
  		value: function render() {
  			var value = this.props.value;


  			var styles = {
  				left: value + '%'
  			};

  			return React.createElement('div', {
  				className: 'uix-multislider__handle',
  				onMouseDown: this.startInteraction,
  				style: styles
  			});
  		}
  	}]);
  	return MultiSliderHandle;
  }(React.PureComponent);

  MultiSliderHandle.defaultProps = {
  	onStart: noop,
  	property: undefined
  };

  exports.Position = Position;
  exports.Surface = Surface;
  exports.PolarSurface = PolarSurface;
  exports.DeltaSurface = DeltaSurface;
  exports.TextInput = TextInput;
  exports.NumericInput = NumericInput;
  exports.NumericInputControls = NumericInputControls;
  exports.Slider = Slider;
  exports.SliderHandle = SliderHandle;
  exports.SliderProgress = SliderProgress;
  exports.SliderTooltip = SliderTooltip;
  exports.SliderGrid = SliderGrid;
  exports.Pad = Pad;
  exports.PadGrid = PadGrid;
  exports.PadHandle = PadHandle;
  exports.PadTooltip = PadTooltip;
  exports.PolarPad = PolarPad;
  exports.PolarPadGrid = PolarPadGrid;
  exports.PolarPadHandle = PolarPadHandle;
  exports.List = List;
  exports.ListItem = ListItem;
  exports.Popup = Popup;
  exports.Portal = Portal;
  exports.Select = Select;
  exports.MultiSlider = MultiSlider;
  exports.MultiSliderHandle = MultiSliderHandle;

  Object.defineProperty(exports, '__esModule', { value: true });

})));



//////////////////
// WEBPACK FOOTER
// ./node_modules/uiuiui/build/uiuiui.umd.js
// module id = 63
// module chunks = 0